(function() {
	'use strict';

	angular.module('quantixApp').controller('RatingListController',
			RatingListController);

	RatingListController.$inject = [ '$scope', 'GenericService', '$rootScope',
			'$location', '$stateParams', '$http', '$window', '$sce',
			'RatingListService', '$timeout', '$uibModal', 'GenericServiceNew',
			'PortfolioService', 'ivhTreeviewBfs', 'ivhTreeviewOptions',
			'ivhTreeviewMgr', 'AlertService', 'baseRequest', 'RATING_LIST',
			'ErrorHandlerService' ];

	function RatingListController($scope, GenericService, $rootScope,
			$location, $stateParams, $http, $window, $sce, RatingListService,
			$timeout, $uibModal, GenericServiceNew, PortfolioService,
			ivhTreeviewBfs, ivhTreeviewOptions, ivhTreeviewMgr, AlertService,
			baseRequest, RATING_LIST, ErrorHandlerService) {
		var vm = this;
		$scope.userId = [];
		$scope.currentbstId = 1;
		$scope.innertbstId = 7;
		$scope.competitorId = 'CRISIL';
		$scope.ratingAgencyData = [];
		vm.selectedsfRatingAgencyType = [];
		$scope.ratingOutlookData = [];
		$scope.ratingScaleData = [];
		$scope.filterUiArray = []; //nikhil
		$scope.amountRatedInstrumentData = [];
		$scope.ratingActionData = [];
		$scope.ratingScaleShort = [];
		$scope.ratingScaleLong = [];
		$scope.instrumentData = [];
		$scope.ratingtype = [];
		vm.selectedinstruments = [];
		vm.selectedsfRatingType = [];
		$scope.constitutionData = [];
		idss = new Array();
		$scope.idStack = [];
		$scope.selectedconstitutionDataTemp = [];
		vm.selectedconstitutionData = [];
		vm.nsicconstitutionData = [];
		$scope.crisilSMERatingList = [];
		$scope.crisilSMERatingTotalCount = [];
		$scope.CrisilNSICRatingList = [];
		$scope.CrisilNSICRatingListCount = [];
		$scope.creditRatingResultList = [];
		$scope.creditRatingTotalCount = [];
		$scope.sfRatingResultList = [];
		$scope.sfTotalCount = [];
		$scope.otherRatingData = [];
		$scope.crisilSFGrid = '';
		$scope.crisilCreditGrid = '';
		$scope.crisilSMEGrid = '';

		// for rating type scale
		$scope.ratingScaleShortTermType = [];
		$scope.ratingScaleLongTermType = [];
		vm.selectedRatingScalesLongTerm = [];
		vm.selectedRatingScalesShortTerm = [];

		// for newly added
		$scope.newlytemp = false;

		// for instruments ISIN
		$scope.selectedratingagenciesForISIN = [];
		$scope.instruIsinGrid = '';
		$scope.instrumentIsinResultList = [];
		$scope.instrumentIsinPaginationList = [];

		// for issuer cooperative

		$scope.issuerTermLongRating = [];
		$scope.enableMe = false;
		$scope.issuerRatings = "";

		vm.singleDate = new Date();

		$scope.singleDate = false;
		$scope.singleDateData = '';

		$scope.fromRatingAmountFlag = false;
		$scope.toRatingAmountFlag = false;
		GenericService.getUserModuleAccessData().then(function(result) {
			$scope.userModuleAccessData = result;
			if (!$scope.userModuleAccessData[RATING_LIST]) {
				ErrorHandlerService.forbiddenError(RATING_LIST);
				return;
			}
		});
		var sectionaccess = {};
		$scope.sectionAccessData = function() {
			GenericService.getUserSectionAccessData().then(function(result) {
				sectionaccess = result;
				$scope.getRatingAgencyMasterList();
			});
		}

		var idss = new Array();
		// selctedlongTermRating=[];

		$scope.setTabSetData = function(tabsetId) {
			$scope.currentbstId = tabsetId;
		}

		$scope.nsicScaleGridList = [];
		$scope.nsicScaleGridIDList = [];
		$scope.nsicScale = function(scale, id) {
			if ($scope.nsicScaleGridList.indexOf(scale) < 0) {
				$scope.nsicScaleGridList.push(scale);
				$scope.nsicScaleGridIDList.push(id);

			} else {
				var index = $scope.nsicScaleGridList.indexOf(scale);
				var indexId = $scope.nsicScaleGridIDList.indexOf(id);
				$scope.nsicScaleGridList.splice(index, 1);
				$scope.nsicScaleGridIDList.splice(indexId, 1);

			}

		}
		$scope.dateModel = {
			selected : "singledateRangeFil"
		};
		$scope.setInnerTabSetData = function(tabsetId) {
			$scope.innertbstId = tabsetId;
			/*if(tabsetId==13){
				$scope.dateModel = "outstanding";
				
			}*/

			$('.toptabsec ul li a').click(function(e) {
				e.preventDefault();
				$('.toptabsec ul li a').removeClass("active");
				$(this).addClass("active");
			});

		}

		$('.toptabs ul li a').click(function() {

			$('.toptabs ul li a').removeClass("active");
			$(this).addClass("active");
		});

		$scope.setTabSetData = function(tabsetId) {

			if (tabsetId == 1) {
				cnt = 0;
				$scope.innertbstId = 7;
				$scope.reSetCreditFilter();
				//$scope.getCrisilCreditRatingsList();

			} else if (tabsetId == 2) {
				//$scope.sfValidation();

				$scope.sfresetFilter();

			} else if (tabsetId == 3) {
				cnt = 0;
				$scope.loccnt = 0;
				$scope.refreshSMEfilter();
				$scope.smeFilterValidation("Initial");

			} else if (tabsetId == 4) {
				cnt = 0;
				$scope.loccnt = 0;
				$scope.refreshNsicFilter();
				$scope.nsicFilterValidation();

			} else if (tabsetId == 5) {
				$scope.getOtherRatingData();
				$scope.refershFundRatingAgencyDD();
				//$scope.getOthersRatingsList("Broker Quality Grading");
			} else if (tabsetId == 6) {
				$scope.getConsolidatedRatingsList();
			} else if(tabsetId == 7){
				$scope.innertbstId = 14;
				$scope.refreshInstrumentsIsin();
			} 
			else if (tabsetId == 8) {
				$scope.refreshUnacceptedRating();
			}
			$scope.currentbstId = tabsetId;

		}

		// start shakti

		$scope.portfsetOrRemoveCompanyAlertFlagIL = function(row, column) {
			var html = '';
			if (row.setOrRemoveAlert == 0) {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagIL(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagIL(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.setOrRemoveCompanyAlertFlagIL = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}

		$scope.portfsetOrRemoveCompanyAlertFlagILCrisilSme2 = function(row,
				column) {
			var html = '';
			if (row.setOrRemoveAlert == 0) {
				html = '<a class="search" onClick= "portfsetOrRemoveCompanyAlertFlagILCrisilSme3(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "portfsetOrRemoveCompanyAlertFlagILCrisilSme3(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.portfsetOrRemoveCompanyAlertFlagILCrisilSme3 = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}

		$scope.portfsetOrRemoveCompanyAlertFlagILCrisilSme = function(row,
				column) {
			var html = '';
			if (row.setOrRemoveAlert == 0) {
				html = '<a class="search" onClick= "portfsetOrRemoveCompanyAlertFlagILCrisilSme1(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "portfsetOrRemoveCompanyAlertFlagILCrisilSme1(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.portfsetOrRemoveCompanyAlertFlagILCrisilSme1 = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}

		//for instrument ISIN

		$scope.portfsetOrRemoveCompanyAlertFlagInstrument = function(row,
				column) {
			var html = '';
			if (row.setOrRemoveAlert == 0) {
				html = '<a class="search" onClick= "portfsetOrRemoveCompanyAlertFlagInstrument1(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "portfsetOrRemoveCompanyAlertFlagInstrument1(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.portfsetOrRemoveCompanyAlertFlagInstrument1 = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}

		//
		$scope.setOrRemoveCompanyAlert = function(companyData) {

			var companyDataDto = {
				companyCode : companyData.companyCode,
				industryId : '',
				portFolioId : '',
				isIndustryLevel : 'N',
				isPortfolioLevel : 'N',
				isCompanyLevel : 'Y'

			};

			if (companyData.setOrRemoveAlert == 0) {
				$scope.setStatus = false;
				$uibModal
						.open({

							templateUrl : 'app/alert components/set alert/companyLevelAlert.html',
							controller : 'CompanyLevelAlert',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								companyData : function() {
									return companyDataDto;
								},
								controllerModule : function() {
									return 'RatingListController';
								},
								parentAccess : function() {
									return $scope;
								},
								isSelectAll : function() {
									return false;
								},
								isInstrumentalFilter : function() {
									return 'N'
								},
								portfolioFilter : function() {
									return ''
								}

							}
						}).closed.then(function() {

					if ($scope.setStatus) {
						companyData.setOrRemoveAlert = 1;
						$timeout(function() {
							if ($scope.currentbstId == 1) {
								$scope.getCrisilCreditRatingsList();
							} else if ($scope.currentbstId == 3) {
								$scope.smeFilterValidation();
							} else if ($scope.currentbstId == 4) {
								$scope.nsicFilterValidation();
							} else if ($scope.currentbstId == 7) {

								$scope.instruIsinGrid.validateNow();
								$scope.instruIsinGrid.rebuild();
								//							//	$scope.getInstrumentsISIN();
							} else if ($scope.currentbstId == 2) {
								$scope.sfValidation();
							}

						}, 100);

						$scope.setStatus = false;
					}
				});
			} else {
				$scope.removeStatus = false;
				$uibModal
						.open({
							templateUrl : 'app/alert components/remove alert/removeAlert-dialog.html',
							controller : 'RemoveAlertDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								alertNameFor : function() {
									return companyData.nameOfCompany;
								},
								companyData : function() {
									return companyDataDto;
								},
								selectedForAll : function() {
									return 'NA';
								},

								selectedForAlertList : function() {
									return [];
								},
								searchedText : function() {
									return 'NA';
								},
								controllerModule : function() {
									return 'RatingListController';
								},
								parentAccess : function() {
									return $scope;
								}
							}
						}).closed.then(function() {
					if ($scope.removeStatus) {
						companyData.setOrRemoveAlert = 0;

						$timeout(function() {

							if ($scope.currentbstId == 1) {
								$scope.getCrisilCreditRatingsList();
							} else if ($scope.currentbstId == 3) {
								$scope.smeFilterValidation();
							} else if ($scope.currentbstId == 4) {
								$scope.nsicFilterValidation();
							} else if ($scope.currentbstId == 7) {

								$scope.instruIsinGrid.validateNow();
								$scope.instruIsinGrid.rebuild();
								//$scope.getInstrumentsISIN();
							} else if ($scope.currentbstId == 2) {
								$scope.sfValidation();
							}

						}, 100);

						$scope.removeStatus = false;
					}

				});

			}

		}

		// end shakti

		// RRHrefData for Crisil SF RatingList
		$scope.getRRHrefData = function(item, column) {

			if (JSON.stringify(item).includes('CRISIL')) {

				return ('<div><a onClick=openSFRatingRRANDCRRDOC(this,"RRDOC") id="'
						+ item.rrDOCFile
						+ '" name='
						+ '  "'
						+ item.companyName
						+ '"' + '>' + item.lastRatingAction + '</a></div>');
			}
			return ('<div><span id=' + item.rrDOCFile + '>'
					+ item.lastRatingAction + '</span></div>');
		}
		// CRRHrefData for Crisil SF RatingList
		$scope.getCRRHrefData = function(item, column) {

			if (JSON.stringify(item).includes('CRISIL')) {
				return ('<div><a onClick=openSFRatingRRANDCRRDOC(this,"CRRDOC") id="'
						+ item.crrDOCFile
						+ '" name='
						+ '  "'
						+ item.companyName + '"' + '>' + item.crrDate + '</a></div>');
			}
			return ('<div><span id=' + item.crrDOCFile + '>' + item.crrDate + '</span></div>');
		}

		// Href for RR and CRR in SF RatingList Tab
		$window.openSFRatingRRANDCRRDOC = function(item, itemType) {

			$scope.redirectToRRANDCRRDOCDetails(item, itemType)
		}
		// Reading RRDOC and CRRDOC form companyProfile for Crisil SF RatingList
		$scope.alertForSFrating = true;
		$scope.redirectToRRANDCRRDOCDetails = function(item, itemType) {
			var crrDOCFile = item.id;
			$scope.fileNameForDownload = crrDOCFile;
			$scope.reportTypeForDownload = itemType
			var type = '';
			var companyNameOfsf = item.name;
			var fd = new FormData();
			fd.append('fileName', crrDOCFile);
			fd.append('docType', itemType);
			fd.append('companyName', companyNameOfsf);
			fd.append('userDoc', '');
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = crrDOCFile.substring(crrDOCFile.lastIndexOf(".") + 1);
			if (filext == 'pdf' && filext != '') {
				jQuery('#SFdocumentPopUp').show();
				jQuery('#SFdocumentPopUpForm').show();
				jQuery('#SFdocumentHTMLPath').hide()
				jQuery('#fileNameHiddenRRCrrSf').val(crrDOCFile);
				jQuery('#documentTypeHiddenSf').val(itemType);
				jQuery('#companyNameTypeHiddenSf').val(companyNameOfsf);
				jQuery('#userDocSf').val($scope.userId);
				jQuery('#SFdocumentPopUpForm').submit();
				jQuery('#SFdocumentPopUp').modal({
					show : 'false'
				});

			} else {
				$http.post(uploadUrl, fd, {
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined,
					}
				}).success(
						function(response) {

							jQuery('#SFdocumentPopUp').hide();
							jQuery('#SFdocumentPopUpForm').hide();
							jQuery('#SFdocumentHTMLPath').show()
							jQuery('#SFdocumentHTMLPath').contents().find(
									'body').html(response);
							jQuery('#SFdocumentPopUp').modal({
								show : 'false'
							});
						}).error(function(response, status, headers, config) {

				});
			}

		}

		// Consolidated Tab
		$scope.getConsolidatedRatingsList = function() {

			RatingListService.getConsolidatedRatingsList().then(function(data) {
				$scope.ConsolidatedRatingsList = data[0]
			}, function(errordata) {
				// message = "Something went wrong, please try again in some
				// time. If the problem persists, please contact
				// Administrator.";
			});
		}

		// Reading RRDOC and CRRDOC form companyProfile for
		// consolidatedRatingList
		$scope.showconsolidatedRatingList = function(fileName, docType) {
			var type = '';
			var companyNameForconsolidated = '';
			$scope.fileNameForDownload = fileName;
			$scope.reportTypeForDownload = docType;
			var fd = new FormData();
			fd.append('fileName', fileName);
			fd.append('docType', docType);
			fd.append('userDoc', '');
			fd.append('companyName', companyNameForconsolidated);
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = fileName.substring(fileName.lastIndexOf(".") + 1);
			if (filext == 'pdf' && filext != '') {
				jQuery('#documentPopUpConsolidated').show();
				jQuery('#documentConsolidatedPathForm').show();
				jQuery('#documentConsolidatedHTMLPath').hide()
				jQuery('#fileNameHiddenRRCrrCons').val(fileName);
				jQuery('#documentTypeHiddenCons').val(docType);
				jQuery('#companyNameTypeHiddenCons').val(
						companyNameForconsolidated);
				jQuery('#userDocCons').val($scope.userId);
				jQuery('#documentConsolidatedPathForm').submit();
				jQuery('#documentPopUpConsolidated').modal({
					show : 'false'
				});

			} else {
				$http.post(uploadUrl, fd, {
					transformRequest : angular.identity,
					//responseType : 'arraybuffer',
					headers : {
						'Content-Type' : undefined,
					}

				/* headers: {
				     'Content-type': 'application/json',
				 }
				 */
				}).success(
						function(response) {
							jQuery('#documentPopUpConsolidated').hide();
							jQuery('#documentConsolidatedPathForm').hide();
							jQuery('#documentHTMLPath').show()
							jQuery('#documentConsolidatedHTMLPath').contents()
									.find('body').html(response);
							jQuery('#documentPopUpConsolidated').modal({
								show : 'false'
							});

						}).error(function(response, status, headers, config) {

				});
			}

		}

		// for CRISILCreditRatingList tab

		//	var crisilCreditGrid = '';
		var creditData = '';
		$scope.inputDataTemp = {};
		$scope.totalCountForCreditRating = 0;
		$scope.totFiltCountForCreditRating = 0;
		vm.searchCompanies = ' ';

		$scope.getCrisilCreditRatingsList = function() {

			// checking to date and from date validation
			$scope.checkErr(vm.fromDate, vm.toDate);

			// for single date range
			if ($scope.singleDate == true) {
				$scope.singleDateData = vm.singleDate;
			} else {
				$scope.singleDateData = '';
			}

			// check in validation for Rating Amount
			if ((vm.fromRatingAmount != undefined && vm.fromRatingAmount != '')
					&& (vm.toRatingAmount != undefined && vm.toRatingAmount != '')) {
				$scope.checkErrForAmounts(vm.fromRatingAmount,
						vm.toRatingAmount);

			} else if (vm.fromRatingAmount != undefined
					&& vm.fromRatingAmount != ''
					|| (vm.toRatingAmount != undefined && vm.toRatingAmount != '')) {

				$scope.checkErrForRatingAmount(vm.fromRatingAmount,
						vm.toRatingAmount);

			} else {
				$scope.fromRatingAmountFlag = false;
				$scope.toRatingAmountFlag = false;
				$scope.minRatingAmount = '';
				$scope.maxRatingAmount = '';
			}

			// checking Rating amount validation
			//$scope.checkErrForRatingAmount(vm.fromRatingAmount, vm.toRatingAmount);
			// for RatingAgency Filter
			if ($scope.ratingAgencyData != undefined) {
				$scope.selectedratingagencies = [];

				var k = 0;
				for (var j = 0; j < $scope.ratingAgencyData.length; j++) {
					if ($scope.ratingAgencyData[j].chekced) {
						k++;
					}

				}
				if (k == 0) {
					for ( var i in $scope.ratingAgencyData) {
						if ($scope.ratingAgencyData[i].name == 'CRISIL Ratings Limited')
							$scope.ratingAgencyData[i].chekced = true;

					}
				}
				for ( var i in $scope.ratingAgencyData) {
					if ($scope.ratingAgencyData[i].chekced == true) {

						$scope.selectedratingagencies
								.push($scope.ratingAgencyData[i]);
					}
				}

				$scope.selectedratingagenciesTemp = $scope.selectedratingagencies
						.map(function(element) {
							return "<" + String(element.labelName) + "<"
						})
			}

			// for ShortTerm Filter
			if ($scope.ratingScaleShort != undefined) {
				$scope.selectedShortTerm = [];
				for ( var i in $scope.ratingScaleShort) {
					if ($scope.ratingScaleShort[i].chekced == true) {
						$scope.selectedShortTerm
								.push($scope.ratingScaleShort[i]);
					}
				}

				$scope.selectedShortTermTemp = $scope.selectedShortTerm
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			// for longTerm filter
			if ($scope.ratingScaleLong != undefined) {
				$scope.selectedLongTerm = [];
				for ( var i in $scope.ratingScaleLong) {
					if ($scope.ratingScaleLong[i].chekced == true) {
						$scope.selectedLongTerm.push($scope.ratingScaleLong[i]);
					}
				}

				$scope.selectedLongTermTemp = $scope.selectedLongTerm
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			// Rating amount

			if ($scope.fromRatingAmountFlag == false
					&& $scope.toRatingAmountFlag == false) {
				$scope.minRatingAmount = '';
				$scope.maxRatingAmount = '';
			} else {
				$scope.minRatingAmount = vm.fromRatingAmount;
				$scope.maxRatingAmount = vm.toRatingAmount;
			}

			// for Outlook

			if ($scope.selectedFinalOutlook == undefined)
				$scope.selectedFinalOutlook = '';

			if ($scope.selected.creditOutlook != undefined) {

				$scope.creditRatingOutlook = [];
				angular.forEach($scope.selected.creditOutlook, function(value,
						key) {

					$scope.creditRatingOutlook.push(value);
				})
				$scope.selectedFinalOutlook = $scope.creditRatingOutlook
						.map(function(element) {
							return "<" + String(element) + "<"
						})
			}

			if ($scope.selected.ratingAction != undefined) {
				$scope.ratingActionData2 = [];
				angular.forEach($scope.selected.ratingAction, function(value,
						key) {
					$scope.ratingActionData2.push(value);
				});

				$scope.selectedRatingActionsTemp = $scope.ratingActionData2
						.map(function(element) {
							return "<" + String(element) + "<"
						})
			}

			if ($scope.selectedRatingActionsTemp == undefined)
				$scope.selectedRatingActionsTemp = '';

			// for Date Range

			if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
				$scope.fromDateTemp = vm.fromDate;
				$scope.toDateTemp = vm.toDate
			} else {
				$scope.fromDateTemp = '';
				$scope.toDateTemp = '';
			}

			// for Duration
			if ($scope.selectedDurationTemp != null
					&& $scope.selectedDurationTemp != undefined) {
				$scope.selectedDuration = $scope.selectedDurationTemp;
			} else {
				$scope.selectedDuration = '';
			}

			// for newly added company 
			if ($scope.selectedDurationForNewlyAddedTemp != null
					&& $scope.selectedDurationForNewlyAddedTemp != undefined) {
				$scope.selectedDurationForNewlyAddedComp = $scope.selectedDurationForNewlyAddedTemp;
			} else {
				$scope.selectedDurationForNewlyAddedComp = '';
			}

			$scope.searchCompany = vm.searchCompanies;

			if (vm.searchCompanies == undefined) {
				$scope.searchCompany = ' ';
			}
			// for issuer rating filter

			if ($scope.issuerTermLongRating != undefined) {
				$scope.selectedIssuerLongTerm = [];
				for ( var i in $scope.issuerTermLongRating) {
					if ($scope.issuerTermLongRating[i].check == true) {
						$scope.issuerRatings = "issuerRating";
						$scope.selectedIssuerLongTerm
								.push($scope.issuerTermLongRating[i]);
					}
				}

				$scope.selectedIssuerLongTermTemp = $scope.selectedIssuerLongTerm
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			if ($scope.issuerRatingTermsRating != undefined) {
				$scope.selectedissuerShortTerm = [];
				for ( var i in $scope.issuerRatingTermsRating) {
					if ($scope.issuerRatingTermsRating[i].check == true) {
						$scope.issuerRatings = "issuerRating";
						$scope.selectedissuerShortTerm
								.push($scope.issuerRatingTermsRating[i]);
					}
				}

				$scope.selectedIssuerShortTermTemp = $scope.selectedissuerShortTerm
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			// for industry
			$scope.selectedIndustriesTemp = [];
			if ($scope.idStack.length == 0) {
				$scope.selectedIndustriesTemp = '';
			} else {
				$scope.selectedIndustriesTemp = $scope.idStack.map(function(
						element) {

					return "<" + String(element) + "<"
				})
			}

			creditData = "{'ratingAction' : '"
					+ $scope.selectedRatingActionsTemp + "','ratingAgency' : '"
					+ $scope.selectedratingagenciesTemp
					+ "', 'minRatingAmount' : '" + $scope.minRatingAmount
					+ "','maxRatingAmount' : '" + $scope.maxRatingAmount
					+ "', 'nameOfCompany' : '" + $scope.searchCompany
					+ "', 'industries' : '" + $scope.selectedIndustriesTemp
					+ "', 'outlook' : '" + $scope.selectedFinalOutlook
					+ "', 'shortTerm' : '" + $scope.selectedShortTermTemp
					+ "', 'longTerm' : '" + $scope.selectedLongTermTemp
					+ "', 'duration' : '" + $scope.selectedDuration
					+ "', 'durationForNewlyAdded' : '"
					+ $scope.selectedDurationForNewlyAddedComp
					+ "', 'issuerNonCorpFlag' : '"
					+ $scope.selectedIssuerNonCooperativeTemp
					+ "', 'issuerShortTerm' : '"
					+ $scope.selectedIssuerShortTermTemp
					+ "', 'issuerLongTerm' : '"
					+ $scope.selectedIssuerLongTermTemp + "', 'fromDate' : '"
					+ $scope.fromDateTemp + "', 'singleDate' : '"
					+ $scope.singleDateData + "', 'issuerRatingFlag' : '"
					+ $scope.issuerRatings + "', 'toDate' : '"
					+ $scope.toDateTemp + "'}";
			creditData = creditData.replace(/\'/g, "\"");
			creditData = creditData.replace(/\</g, "\'");

			$scope.inputDataTemp = creditData;

			RatingListService
					.getCrisilCreditRatingsList(creditData)
					.then(
							function(data) {

								$scope.creditRatingResultList = data.creditRatingResultList[1];
								$scope.creditRatingTotalCount = data.creditRatingResultList[2];
								$scope.totalUniqueCount = data.creditRatingResultList[3];

								$scope.userId = data.creditU[0];
								$scope.totalCountForCreditRating = data.creditRatingResultList[2];
								$scope.totFiltCountForCreditRating = $scope.creditRatingResultList.length;

								$scope.crisilCreditGridData = {
									dataProvider : $scope.creditRatingResultList,
									delegate : $scope
								}
								$timeout(
										function() {
											$scope.crisilCreditGrid
													.setPreservePager(true);
											$scope.crisilCreditGrid
													.setDataProvider($scope.creditRatingResultList);
											if ($scope.creditRatingResultList.length > 0) {
												$scope.crisilCreditGrid
														.setTotalRecords($scope.creditRatingTotalCount);
											} else {
												$scope.crisilCreditGrid
														.setTotalRecords(0);
											}
											$scope.crisilCreditGrid
													.validateNow();
											$scope.crisilCreditGrid.rebuild();
										}, 1000);
								$scope.CrisilCreditRatingsListFilter = inputData;
							}, function(errordata) {
								// message = "Something went wrong, please try
								// again in
								// some
								// time. If the problem persists, please contact
								// Administrator.";

							});
		}

		// RRDOC for CreditRatingList
		$scope.getHrefData = function(item, column) {

			if (item.ratingAgency.includes('CRISIL')) {
				return ('<div><a onClick=openCreditRatingRRANDCRRDOC(this,"RRDOC") id="'
						+ item.fileNameForRRDOC
						+ '" name='
						+ '  "'
						+ item.companyName
						+ '"'
						+ '>'
						+ item.lastRatingActionDate + '</a></div>');
			}
			return ('<div><span id=' + item.fileNameForRRDOC + '>'
					+ item.lastRatingActionDate + '</span></div>');
		}

		// CRR DOC for CreditRatingList
		$scope.getHrefCRRData = function(item, column) {
			if (item.ratingAgency.includes('CRISIL')) {
				return ('<div><a onClick=openCreditRatingRRANDCRRDOC(this,"CRRDOC") id="'
						+ item.fileNameForCRRDOC
						+ '" name= "'
						+ item.companyName + '"' + '>' + item.crrDate + '</a></div>');
			}
			return ('<div><span id=' + item.fileNameForCRRDOC + '>'
					+ item.crrDate + '</span></div>');
		}

		// Href for RR and CRR in Credit RatingList Tab
		$window.openCreditRatingRRANDCRRDOC = function(item, itemType) {

			$scope.redirectToCRRDOCDetails(item, itemType)
		}
		// Reading RRDOC and CRRDOC form companyProfile for CreditRatingList
		$scope.alretForCreditRating = true;
		$scope.redirectToCRRDOCDetails = function(item, itemType) {

			var fileNameForCRRDOC = item.id;
			$scope.fileNameForDownload = item.id;
			$scope.reportTypeForDownload = itemType;
			var type = '';
			var companyNameTemp = item.name;
			var fd = new FormData();
			fd.append('fileName', fileNameForCRRDOC);
			fd.append('docType', itemType);
			fd.append('companyName', companyNameTemp);
			fd.append('userDoc', '');
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = fileNameForCRRDOC.substring(fileNameForCRRDOC
					.lastIndexOf(".") + 1);

			if (filext == 'pdf' && filext != '') {
				jQuery('#documentPath').show();
				jQuery('#documentPathForm').show();
				jQuery('#documentHTMLPath').hide()
				jQuery('#fileNameHiddenRRCrrCredit').val(fileNameForCRRDOC);
				jQuery('#documentTypeHiddenCredit').val(itemType);
				jQuery('#companyNameTypeHiddenCredit').val(companyNameTemp);
				jQuery('#userDocCredit').val($scope.userId);
				jQuery('#documentPathForm').submit();
				jQuery('#documentPopUp').modal({
					show : 'false'
				});

			} else {
				$http.post(uploadUrl, fd, {
					transformRequest : angular.identity,
					//	responseType : 'arraybuffer',
					headers : {
						'Content-Type' : undefined,
					}
				}).success(
						function(response) {
							jQuery('#documentPath').hide();
							jQuery('#documentPathForm').hide();
							jQuery('#documentHTMLPath').show()
							jQuery('#documentHTMLPath').contents().find('body')
									.html(response);
							jQuery('#documentPopUp').modal({
								show : 'false'
							});

						}).error(function(response, status, headers, config) {

				});
			}

		}
		// $scope.setTabSetData(1);

		// for Rating Agency Filter Data
		$scope.selectAll = {
			checked : false
		};
		$scope.changeAgencies = function(selectAll) {
			if (selectAll) {
				angular.forEach($scope.ratingAgencyData, function(val, key) {
					val.chekced = true;
				});
			} else {
				angular.forEach($scope.ratingAgencyData, function(val, key) {
					val.chekced = false;
				});
			}

		}
		$scope.getRatingAgencyMasterList = function() {

			if ($scope.ratingAgencyData.length == 0) {
				RatingListService.getRatingAgencyMasterList().then(
						function(data) {
							$scope.ratingAgencyData = data;
							vm.selectedsfRatingAgencyType = [ {
								"id" : 6,
								"name" : "CRISIL Ratings Limited",
								"labelName" : "CRISIL",
								"chekced" : true
							} ];
							$scope.reSetCreditFilter()
							//$scope.getCrisilCreditRatingsList();

						}, function(error) {

						});
			}

		}

		// for Rating Type Filter Data

		$scope.getRatingScales = function() {
			$scope.mergeArray = [];
			if ($scope.ratingScaleData.length == 0) {
				PortfolioService.getRatingScaleMasterList().then(
						function(data) {
							$scope.ratingScaletype = data;

							angular.forEach(data, function(value, key) {

								if (key === 'LongTerm') {
									$scope.ratingScaleLong = value;
									$scope.issuerTermLongRating = value;

								} else if (key === 'ShortTerm') {
									$scope.ratingScaleShort = value;
									$scope.issuerRatingTermsRating = value;

									// $scope.mergeArray.concat(value);

								}
								/*
								 * $scope.mergeArray = $scope.ratingScaleLong
								 * .concat($scope.ratingScaleShort);
								 */
							});

						}, function(error) {

						});
			}
		}
		$scope.markAll = {
			checked : false
		};
		$scope.markAll1 = {
			checked : false
		};
		$scope.changeRatingType = function(markAll, markAll1, type) {
			if (type == 'shortTerm') {

				if (markAll) {
					angular.forEach($scope.ratingScaleShort,
							function(val, key) {
								val.chekced = true;
							});
				} else {
					angular.forEach($scope.ratingScaleShort,
							function(val, key) {
								val.chekced = false;
							});
				}

			} else if (type == 'longTerm') {

				if (markAll1) {
					angular.forEach($scope.ratingScaleLong, function(val, key) {
						val.chekced = true;
					});
				} else {
					angular.forEach($scope.ratingScaleLong, function(val, key) {
						val.chekced = false;
					});
				}
			}

		}
		// for outlook filter
		var outlookTemp = [];
		$scope.outlookFilter = function(data) {
			$scope.outlookTemp = data;

		}
		// for Rating Action Filter
		$scope.getRatingActions = function() {
			// alert(selectedActions);
			if ($scope.ratingActionData.length == 0) {
				PortfolioService.getRatingActionMasterList().then(

				function(data) {
					$scope.ratingActionData = data;

				}, function(error) {

				});
			}
		}

		$scope.Selected = {
			ratingAction : []
		}
		// for Duration Filter
		$scope.showData = false;
		$scope.duration = function(durationData) {
			if (durationData == 'option1') {
				$scope.showData = true;
				$scope.singleDate = false;
				$scope.singleDateData = '';
				$scope.selectedDuration = '';
				$scope.selectedDurationTemp = '';
				$scope.enableNewlyAdded = false;
				$scope.newlytemp = false;
			} else if (durationData == 'singleDate') {
				vm.fromDate = "";
				vm.toDate = "";
				$scope.singleDate = true;
				$scope.showData = false;
				$scope.selectedDuration = '';
				$scope.selectedDurationTemp = '';

			} else if (durationData != 'option1') {
				vm.fromDate = "";
				vm.toDate = "";
				$scope.selectedDurationTemp = durationData;
				$scope.singleDateData = '';
				$scope.singleDate = false;
				$scope.showData = false;
			}

		}
		// get filter list of companies
		$scope.searchCnameForCreditRating = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a compnay
			$scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings,
								"CreditRatingList")
						.then(
								function(data) {
									$scope.companies = data;

									if ($scope.companies.length == 0) {
										$scope.ifError = true;
										$scope.errorMessages = "Please search the appropriate company!";
										//										AlertService
										//												.error("Please search the appropriate company!");
									} else {
										$scope.ifError = false;
										$scope.errorMessages = "";
									}

								},
								function(errordata) {
									$scope.ifError = true;
									$scope.errorMessages = "Please search the appropriate company!";
									AlertService
											.error("Error while searching company!");
								});
			}

		}
		$scope.selectedOutlookData = [];
		$scope.OutlookFun = function(data, data1) {

			$scope.selectedOutlookData.push(data);
			if ($scope.selectedOutlookData.length > 0 && data1 == true) {
				for ( var i in $scope.selectedOutlookData) {
					$scope.selectedOutlookData[i];
				}
				$scope.selectedFinalOutlook = $scope.selectedOutlookData
						.map(function(element) {
							return "<" + String(element) + "<"
						});
			}
		}
		// outlook for creditRatingList
		$scope.selected = {
			creditOutlook : []
		}
		// for RatingAction
		$scope.selected = {
			ratingAction : []
		}
		//Date validation

		$scope.checkErr = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;
			var curDate = new Date();
			if ((fromDate != '' && fromDate != undefined)
					&& (toDate != '' && toDate != undefined)) {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;

					// Added Bhadra For Task Id: 49781 
					$scope.fromDateTrue = true;
				}

				if (new Date(fromDate) < curDate) {
					$scope.fromDateTrue = true;
					$scope.toDateTrue = true;

				} else {
					$scope.fromDateTrue = false;

					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
				}
			} else {
				$scope.fromDateTrue = false;
				$scope.toDateTrue = false;
			}
		};

		// filter validation data
		$scope.inputDataTemp = {};
		$scope.totalCountForCreditRating = 0;
		$scope.totFiltCountForCreditRating = 0;
		var inputData = '';

		$scope.crisilCreditGridCompletion = function(event) {

			$scope.crisilCreditGrid = event.target;
			$scope.crisilCreditGrid.setPreservePager(true);
			$scope.crisilCreditGrid
					.setDataProvider($scope.creditRatingResultList);
			if ($scope.creditRatingResultList.length > 0) {
				$scope.crisilCreditGrid
						.setTotalRecords($scope.creditRatingTotalCount);
			} else {
				$scope.crisilCreditGrid.setTotalRecords(0);
			}
			$scope.crisilCreditGrid.validateNow();
		};

		var creditRatingGrid = '';
		var creditRatingFilter = '';

		$scope.filterPageSortChangeHandlerCreditRatingList = function(evt1) {

			creditRatingGrid = evt1.target;
			creditRatingFilter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.inputDataTemp,
				typeOfRatingList : 'Credit_RatingList',
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};

			baseRequest('api/ratingList/getFilterServerSidePagination',
					creditRatingFilter)
					.then(
							function(response) {
								creditRatingGrid.setPreservePager(true);
								creditRatingGrid
										.setDataProvider(response.data.typeOfRatingList);
								$scope.creditPaginationList = response.data.typeOfRatingList;
								if ($scope.creditPaginationList.length > 0) {
									$scope.crisilCreditRatingTotalPaginationCounts = response.data.totalCountOfList;
									creditRatingGrid
											.setTotalRecords($scope.crisilCreditRatingTotalPaginationCounts);
								} else {
									creditRatingGrid.setTotalRecords(0);
								}
								creditRatingGrid.validateNow();

							});

		}

		// Add Previous Rating for CreditRatingList

		$scope.addORremoveFlag = false;
		$scope.addORRemoveFun = function() {
			$scope.addORremoveFlag = $scope.addORremoveFlag;

			if ($scope.addORremoveFlag == true) {
				$scope.addORremove = 'add';
				$scope.previousRatingText = 'Remove';
				$scope.crisilCreditGridDataForAdd = {
					dataProvider : $scope.creditRatingResultList,
					delegate : $scope
				}
			} else if ($scope.addORremoveFlag == false) {
				$scope.addORremove = 'remove';
				$scope.previousRatingText = 'Add';
				$scope.crisilCreditGridDataForRemove = {
					dataProvider : $scope.creditRatingResultList,
					delegate : $scope
				}
				$scope.addORremoveFlag = false;

			}

			$scope.addORremoveFlag = !$scope.addORremoveFlag;

		}
		$scope.addORRemoveFun();

		$scope.reSetCreditFilter = function() {
			cnt = 0;
			$scope.selectAllind(false);
			$scope.allRatingTrue = false;
			$scope.selected.creditOutlook = [];
			$scope.selected.ratingAction = [];
			$scope.selectedRatingActionsTemp = '';
			vm.searchCompanies = ' ';
			$scope.outlookTemp = '';
			vm.fromRatingAmount = '';
			vm.toRatingAmount = '';
			vm.toDate = '';
			vm.fromDate = '';
			$scope.selectedIssuerNonCooperativeTemp = '';
			$scope.issureNonCor = false;
			angular.forEach($scope.ratingAgencyData, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.ratingScaleShort, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.ratingScaleLong, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.issuerTermLongRating, function(val, key) {
				val.check = false;
			});

			angular.forEach($scope.issuerRatingTermsRating, function(val, key) {
				val.check = false;

			});

			$scope.selectAll.checked = false;
			$scope.selectedDurationTemp = '';
			$scope.selectedDurationForNewlyAddedTemp = ''; //nikhil
			$scope.newlytemp = false;
			$scope.markAll.checked = false;
			$scope.markAll1.checked = false;
			$scope.markAll2.check = false;
			$scope.totalCountForCreditRating = 0;
			$scope.totFiltCountForCreditRating = 0;
			$scope.selectedIssuerShortTermTemp = '';
			$scope.selectedIssuerLongTermTemp = '';
			$scope.issuerRatings = "";
			$scope.showData = false;
			vm.singleDate = new Date();
			$scope.singleDate = true;
			//$scope.duration("singleDate");
			$scope.enableNewlyAdded = false;
			$scope.dateModel = {
				selected : 'singledateRangeFil'
			};
			$scope.getCrisilCreditRatingsList();
			$scope.innertbstId = 7;
			//			$('.toptabthree ul li a').click(function(e) {
			//				e.preventDefault();
			//				$(this).addClass("active");
			//			});
			$timeout(function() {
				//$scope.crisilCreditGrid.setPageIndex(0);
			}, 100);

		}

		$scope.refreshCreditRatingTab = function() {
			$scope.selected.creditOutlook = [];
			$scope.selected.ratingAction = [];

			vm.searchCompanies = ' ';
			$scope.outlookTemp = '';
			vm.fromRatingAmount = '';
			vm.toRatingAmount = '';
			vm.toDate = '';
			vm.fromDate = '';
			angular.forEach($scope.ratingAgencyData, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.ratingScaleShort, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.ratingScaleLong, function(val, key) {
				val.chekced = false;
			});

			$scope.selectAll.checked = false;
			$scope.selectedDurationTemp = '';
			$scope.selectedDurationForNewlyAddedTemp = '';
			$scope.markAll.checked = false;
			$scope.markAll1.checked = false;
			$scope.totalCountForCreditRating = 0;
			$scope.totFiltCountForCreditRating = 0;
			$scope.selectedIssuerShortTermTemp = '';
			$scope.selectedIssuerLongTermTemp = '';
			$scope.issuerRatings = "";

		}

		//For SF RatingList  
		// get filter list of compnaies
		$scope.searchFilterForSFRatingList = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a compnay
			$scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings, "SFRatingList")
						.then(
								function(data) {

									$scope.sfcompanies = data;

									if ($scope.sfcompanies.length == 0) {
										AlertService
												.error("Please search the appropriate company!");
									}
								},
								function(errordata) {
									AlertService
											.error("Error while searching company!");
								});
			}

		}

		$scope.ratingOutlookData = [];
		$scope.getRatingOutlooks = function() {

			if ($scope.ratingOutlookData.length == 0) {
				PortfolioService.getRatingOutlookMasterList().then(
						function(data) {
							$scope.ratingOutlookData = data;

						}, function(error) {

						});
			}

		}

		// selected outlook for SF
		$scope.selected = {
			sfOutlook : []
		};

		var sfdata = '';
		$scope.sfExDataTemp = {};
		// search filter
		$scope.sfValidation = function() {

			// for sf RatingType details
			if (vm.selectedsfRatingType != undefined) {
				$scope.selectedRatingtypeTemp = vm.selectedsfRatingType
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			// for ratingAgency detail
			if (vm.selectedsfRatingAgencyType != undefined) {
				$scope.selectedRatingAgencytypeTemp = vm.selectedsfRatingAgencyType
						.map(function(element) {
							return "<" + String(element.labelName) + "<"
						})

			}

			// for sf instrument details
			if (vm.selectedinstruments != undefined) {
				$scope.selectedinstrumentsTemp = vm.selectedinstruments
						.map(function(element) {
							return "<" + String(element.id) + "<"
						})
			}

			// search SF companies
			if (vm.sfsearchCompanies == undefined)
				vm.sfsearchCompanies = ' ';

			// for RatingOutlook
			if ($scope.selected.sfOutlook != undefined) {

				$scope.ratingOutlookData2 = [];

				angular.forEach($scope.selected.sfOutlook,
						function(value, key) {

							$scope.ratingOutlookData2.push(value);
						})

				$scope.selectedRatingOutlookTemp = $scope.ratingOutlookData2
						.map(function(element) {
							return "<" + String(element) + "<"
						})
			}

			// for SF RatingAmount
			if (vm.fromsfRatingAmount != undefined
					&& vm.fromsfRatingAmount != '') {
				$scope.minsfRatingAmount = vm.fromsfRatingAmount;
			} else {
				$scope.minsfRatingAmount = '';
			}
			if (vm.tosfRatingAmount != undefined && vm.tosfRatingAmount != '') {
				$scope.maxsfRatingAmount = vm.tosfRatingAmount;
			} else {
				$scope.maxsfRatingAmount = '';
			}

			sfdata = "{'ratingType' : '" + $scope.selectedRatingtypeTemp
					+ "','instrumentType' : '" + $scope.selectedinstrumentsTemp
					+ "', 'minsfRatingAmount' : '" + $scope.minsfRatingAmount
					+ "','maxsfRatingAmount' : '" + $scope.maxsfRatingAmount
					+ "', 'nameOfCompany' : '" + vm.sfsearchCompanies
					+ "', 'outlook' : '" + $scope.selectedRatingOutlookTemp
					+ "', 'ratingAgency' : '"
					+ $scope.selectedRatingAgencytypeTemp
					+ "', 'issuerNonCorpFlag' : '"
					+ $scope.selectedIssuerNonCooperativeTemp + "'}";
			sfdata = sfdata.replace(/\'/g, "\"");
			sfdata = sfdata.replace(/\</g, "\'");

			$scope.sfExDataTemp = sfdata;

			RatingListService
					.getCrisilSFRatingsList(sfdata)
					.then(
							function(data) {

								$scope.sfRatingResultList = data.sfRatingResultList[1];
								$scope.sfTotalCount = data.sfRatingResultList[2];
								$scope.sfUniqueCount = data.sfRatingResultList[3];

								$scope.totCntForSfRating = data.sfRatingResultList[2];

								$scope.totFilCntForSfRating = $scope.sfRatingResultList.length;

								$scope.crisilSFGridData = {
									dataProvider : $scope.sfRatingResultList,
									delegate : $scope
								}

								$timeout(
										function() {
											$scope.crisilSFGrid
													.setPreservePager(true);
											$scope.crisilSFGrid
													.setDataProvider($scope.sfRatingResultList);
											if ($scope.sfRatingResultList.length > 0) {
												$scope.crisilSFGrid
														.setTotalRecords($scope.sfTotalCount);
											} else {
												$scope.crisilSFGrid
														.setTotalRecords(0);
											}
											$scope.crisilSFGrid.validateNow();
											$scope.crisilSFGrid.rebuild();

										}, 100);

							}, function(errordata) {

							});

		}

		$scope.sfresetFilter = function() {

			$scope.selected.sfOutlook = [];
			vm.selectedinstruments = [];
			vm.selectedsfRatingType = [];
			vm.selectedsfRatingAgencyType = [];//nikhil
			vm.selectedsfRatingAgencyType = [ {
				"id" : 6,
				"name" : "CRISIL Ratings Limited",
				"labelName" : "CRISIL",
				"chekced" : true
			} ];
			vm.sfsearchCompanies = null;
			vm.fromsfRatingAmount = '';
			vm.tosfRatingAmount = '';
			$scope.totCntForSfRating = 0;
			$scope.totFilCntForSfRating = 0;
			$scope.issureNonCor = false; // for issue non
			$scope.selectedIssuerNonCooperativeTemp = '';
			$scope.sfValidation();
			$timeout(function() {
				//$scope.crisilSFGrid.setPageIndex(0);
			}, 100);
		}

		$scope.crisilSFGridCompletion = function(event) {
			$scope.crisilSFGrid = event.target;
			$scope.crisilSFGrid.setPreservePager(true);
			$scope.crisilSFGrid.setDataProvider($scope.sfRatingResultList);
			if ($scope.sfRatingResultList.length > 0) {
				$scope.crisilSFGrid.setTotalRecords($scope.sfTotalCount);

			} else {
				$scope.crisilSFGrid.setTotalRecords(0);
			}
			$scope.crisilSFGrid.validateNow();
		};

		$scope.filterPageSortChangeHandlerSFRatingList = function(evt1) {
			var grid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.sfExDataTemp,
				typeOfRatingList : 'SF_RatingList',
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",
			};

			baseRequest('api/ratingList/getFilterServerSidePagination', filter)
					.then(
							function(response) {
								grid.setPreservePager(true);
								grid
										.setDataProvider(response.data.typeOfRatingList);
								$scope.sfRatingPaginationList = response.data.typeOfRatingList;
								if ($scope.sfRatingPaginationList.length > 0) {
									$scope.crisilSFRatingTotalPaginationCount = response.data.totalCountOfList;
									grid
											.setTotalRecords($scope.crisilSFRatingTotalPaginationCount);
								} else {
									grid.setTotalRecords(0);
								}
								grid.validateNow();

							});

		}
		$scope.getInstrumentList = function() {
			if ($scope.instrumentData.length == 0) {
				RatingListService.getInstrumentList().then(function(data) {
					$scope.instrumentData = data;
				}, function(error) {

				})
			}
		}

		$scope.getSfRatingType = function() {
			if ($scope.ratingtype.length == 0) {
				RatingListService
						.getSfRatingType()
						.then(
								function(data) {
									$scope.ratingtype = data;
									for (var i = 0; i < $scope.ratingtype.length; i++) {

										var names = $scope.ratingtype[i].name;

										if (names.includes('CRISIL')) {

											$scope.ratingtype[i].name = names
													.replace('CRISIL', '');
											$scope.ratingtype[i].name = $scope.ratingtype[i].name
													.trim($scope.ratingtype[i].name);
											var newName = $scope.ratingtype[i].name;
											if (newName.includes('(SO)')) {
												$scope.ratingtype[i].name = newName
														.replace('(SO)', '');
												$scope.ratingtype[i].name = $scope.ratingtype[i].name
														.trim($scope.ratingtype[i].name);
											} else if (newName
													.includes('(fso)')) {
												$scope.ratingtype[i].name = newName
														.replace('(fso)', '');
											}
										}
									}

								}, function(error) {

								})
			}
		}

		// for SME FIlter

		// /search by name for SME
		$scope.searchFilterForSMERatingList = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a compnay
			if (typedthings == "cleanData") {
				$scope.smecompanies = null;
			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings, "SMERatingList")
						.then(
								function(data) {
									$scope.smecompanies = data;

									if ($scope.smecompanies.length == 0) {
										AlertService
												.error("Please search the appropriate company!");
									}
								},
								function(errordata) {
									AlertService
											.error("Error while searching company!");
								});
			}

		}
		$scope.getConstitutionData = function() {
			if ($scope.constitutionData.length == 0) {
				RatingListService.getConstitutionData().then(function(data) {
					$scope.constitutionData = data;
				}, function(error) {

				})
			}
		}

		/* Industry part */
		// for industry tree
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		$scope.viewTreeIndustry = false;
		var indgri = null;
		var arrayind = new Array();
		var allKeysInd = [];
		var allKeysLocations = [];
		var filterselectall = false;
		// for industry tree

		$scope.onGridCreationCompletedIndustry = function(event) {

			if (event != null) {
				indgri = event.target;
				indgri.enableHeightAutoAdjust = true;
				indgri.validateNow();

			} else {
				indgri.enableHeightAutoAdjust = true;
				indgri.clearFilter();
				indgri.expandAll();
				indgri.setFilterValue('label', firstcharind, indgri);
				indgri.validateNow();
			}
		};
		$scope.selectedIndustries = [];
		$scope.selectAllind = function(flag) {
			allKeysInd = [];
			if (flag) {
				$scope.noinddata = false;
				arrayind = [];
				$scope.selectedIndustries = [];
				if (indfiltervaluchanged) {
					filterselectall = true;
					$scope.industryall = false;
				} else {
					filterselectall = false;
					$scope.industryall = true;
				}

				ivhTreeviewBfs($scope.sampleIndustrydata, opts, function(node) {

					if (indfiltervaluchanged) {

						if (node.label.toLowerCase().includes(firstcharind)) {
							$scope.selectedIndustries.push(node.id);
							allKeysInd.push(node.id);
							if (node.children.length > 0) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysInd.push(childnode.id);
								});
							}

						}

					} else {
						allKeysInd.push(node.id);
					}

				});

				$scope.badgeStringInd = $scope.selectedIndustries.toString();

				$timeout(function() {
					indgri.setSelectedKeys(allKeysInd, false);
				}, 100);
			} else {
				arrayind = [];
				$scope.selectedIndustries = [];
				$scope.industryall = false;
				if (indgri != null) {
					indgri.clearSelection();
					indgri.clearAllFilters();
					indgri.clearChanges();
					indfiltervaluchanged = false;
					indgri.collapseAll();
					indgri.validateNow();
				}

				idss = [];
				$scope.idStack = [];
				// indgri.rebuild();
				// alert($scope.selectedProducts);
			}
		}

		$scope.ind = {
			indstatus : false
		};
		$scope.ind.indstatus = false;
		var cnt = 0;

		$scope.setIndustryTree = function() {

			$scope.ind.indstatus = true;
			// $scope.showResult = false;

			$scope.gridOptionsSec = {
				dataProvider : $scope.sampleIndustrydata,
				delegate : $scope
			};

			if (cnt == 0) {
				cnt = 1;
				$timeout(function() {
					var l = document.getElementById('industryButton');
					l.click();
				}, 100, false);

			}

			//$scope.selectAllind(true);
		}

		$scope.getChildIndustry = function(childArray) {

			if (childArray.children.length <= 0) {
				$scope.idStack.push(childArray.id);
				return childArray.id;
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					// return $scope.getChildIndustry(childArr);
					$scope.getChildIndustry(childArr);
				}
			}

		}

		$scope.spliceChildIndustry = function(childArray) {
			var subchild = childArray.children[0];
			if (($scope.idStack.indexOf(childArray.id) != -1)
					&& (childArray.children.length <= 0
							|| angular.isUndefined(subchild.id) || subchild.id == childArray.id)) {
				$scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					$scope.spliceChildIndustry(childArr);
				}
			}

		}

		$scope.spliceChildIndustryFromarrayind = function(childArray) {
			var subchild = childArray.children[0];

			if (arrayind.indexOf(childArray.label) != -1) {
				arrayind.splice(arrayind.indexOf(childArray.label), 1);
			}

			for (var i = 0; i < childArray.children.length; i++) {
				var childArr = childArray.children[i];
				$scope.spliceChildIndustryFromarrayind(childArr);
			}

		}

		$scope.idStack = [];
		idss = new Array();
		$scope.setbadgesforIndustry = function(evt) {
			var grid = evt.target;
			if (evt.isItemSelected) {
				$scope.noinddata = false;

				if (evt.item.children.length > 0) {
					// to remove already selected child
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						$scope.spliceChildIndustry(childArr);
						$scope.spliceChildIndustryFromarrayind(childArr);
					}
					//ended
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						var id = $scope.getChildIndustry(childArr);
						idss.push(id);
					}
				} else {
					idss.push(evt.item.id);
					$scope.idStack.push(evt.item.id)
				}
				arrayind.push(evt.item.label);
			} else {

				if (evt.item.children.length == 0) {
					if (idss.indexOf(evt.item.id) != -1) {
						idss.splice(idss.indexOf(evt.item.id), 1);
					}
					if ($scope.idStack.indexOf(evt.item.id) != -1) {
						$scope.idStack.splice($scope.idStack
								.indexOf(evt.item.id), 1);
					}
				} else {
					idss.splice(idss.indexOf(evt.item.id),
							evt.item.children.length);
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						$scope.spliceChildIndustry(childArr);
					}

				}

				if (arrayind.indexOf(evt.item.label) != -1) {
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
				} else if ($scope.industryall) {
					$scope.industryall = false;
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				}

				else if (indgri.getSelectedObjects().length > 1) {
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				} else {
					arrayind = [];
				}
			}
			$timeout(
					function() {
						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringInd = $scope.selectedIndustries
								.toString();

						if ($scope.badgeStringInd.length > 30) {
							for (var i = 0; i < $scope.selectedIndustries.length; i++) {
								if ($scope.selectedIndustries[i].length > 10) {
									$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						} else {
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						}
					}, 100);
		}

		var indfiltervaluchanged = false;
		var locfiltervaluchanged = false;
		var firstcharind = '';

		$scope.filerPageSortHandle = function(event) {
			setTimeout(
					function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							// grid.rebuild();
							indfiltervaluchanged = false;

						}
						if (!indfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharind = filter.filterExpressions[0].expression
									indfiltervaluchanged = true;
									$scope
											.onGridCreationCompletedIndustry(null);
								}
							}
						}
					}, 1);
		};

		$scope.onDynamicLevelCind = function(event) {
			// alert("dynamic");
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.disablecellind = function(cell) {
			return (cell.getLevel().getNestDepth() != 5);
		}// fn end

		$scope.gettooltipforIndustry = function(item, column) {
			var html = "<label title='" + item.label + "'>" + item.label
					+ "</label>"
			return html;
		};// fn end

		// getting Industry data
		$scope.gridIndustryTree = function() {

			$http.post('api/masterData/get4thLevelIndustryTreeData').success(
					function(data) {
						$scope.sampleIndustrydata = data;
						$scope.indTreeData = $scope.sampleIndustrydata;
						$scope.temp = $scope.indTreeData;
					}).error(function(data) {

			});

		}// end of industry

		// Location filter
		var locgri = null;
		var arrayloc = new Array();

		$scope.selectAllloc = function(flag) {
			allKeysLocations = [];
			if (flag) {
				arrayloc = []
				$scope.selectedLocations = [];

				// $scope.selectAllflagloc = true;

				if (locfiltervaluchanged) {
					$scope.selectAllflagloc = false;
				} else {
					$scope.selectAllflagloc = true;
				}

				ivhTreeviewBfs($scope.sampletreedata, opts, function(node) {
					// allKeysLocations.push(node.id);
					if (locfiltervaluchanged) {

						if (node.label.toLowerCase().includes(firstcharloc)) {
							$scope.selectedLocations.push(node.label);
							allKeysLocations.push(node.id);

							if (node.children) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysLocations.push(childnode.id);
								});
							}

						}

					} else {
						allKeysLocations.push(node.id);
					}
				});

				$timeout(function() {
					locgri.setSelectedKeys(allKeysLocations, false);
				}, 100);

			} else {
				arrayloc = [];
				$scope.selectedLocations = [];
				$scope.selectAllflagloc = false;
				if (locgri != null) {
					locgri.clearSelection();
					locgri.clearAllFilters();
					locgri.collapseAll();
					locfiltervaluchanged = false;
				}
				// alert($scope.selectedProducts);
			}
		}

		$scope.locbuttonid = 'locationButton_' + $scope.name;
		$scope.indgrididtohide = "gridIndTreeData2" + $scope.name;
		$scope.locgrididtohide = "gridlocTreeData1" + $scope.name;
		$scope.loccnt = 0;
		$scope.setLocationTree = function() {

			$('#gridIndTreeData2' + $scope.name).hide();
			// $scope.loc.locstatus = true;
			$scope.showResult = false;

			$scope.gridOptionsSecLoc = {
				dataProvider : $scope.sampletreedata,
				delegate : $scope
			};

			if ($scope.loccnt == 0) {
				$scope.loccnt = 1;
				$timeout(function() {
					var l = document.getElementById('locationButton_'
							+ $scope.name);
					l.click();
				}, 100, false);
			}
			//$scope.selectAllloc(false);
		}

		$scope.setbadgesforLocation = function(evt) {

			var grid = evt.target;
			if (evt.isItemSelected) {
				arrayloc.push(evt.item.label);

			} else {
				arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
			}

			$timeout(
					function() {

						$scope.selectedLocations = angular.copy(arrayloc);
						$scope.badgeStringLoc = $scope.selectedLocations
								.toString();

						if ($scope.badgeStringLoc.length > 30) {
							for (var i = 0; i < $scope.selectedLocations.length; i++) {
								if ($scope.selectedLocations[i].length > 10) {
									$scope.selectedLocations[i] = $scope.selectedLocations[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringLoc = $scope.selectedLocations
									.toString();
						} else {
							$scope.badgeStringLoc = $scope.selectedLocations
									.toString();
						}

					}, 100);

		}

		$scope.onGridCreationCompletedLocation = function(event) {

			if (event != null) {
				locgri = event.target;
				locgri.enableHeightAutoAdjust = true;
				locgri.validateNow();
			} else {
				locgri.enableHeightAutoAdjust = true;
				locgri.clearFilter();
				locgri.expandAll();
				locgri.setFilterValue('label', firstcharloc, indgri);
				locgri.validateNow();
			}
		};
		var firstcharloc = '';
		$scope.filerPageSortHandleloc = function(event) {
			setTimeout(
					function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							// grid.rebuild();
							locfiltervaluchanged = false;

						}
						if (!locfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharloc = filter.filterExpressions[0].expression
									locfiltervaluchanged = true;
									$scope
											.onGridCreationCompletedLocation(null);
								}
							}
						}
					}, 1);
		};

		function getLocationTree() {

			var promise = GenericService.getZonalLocationDetailsdata();
			promise.then(function(data) {
				$scope.sampletreedata = data;

				$scope.gridOptionsSecLoc = {
					dataProvider : $scope.sampletreedata,
					delegate : $scope
				};

			}, function(response, status, headers, config) {
				ErrorHandlerService.handleError(response, status, headers,
						config);
			});
		}

		getLocationTree();

		$scope.getselectedKeysForLocation = function() {
			var peerGroupLocationGridKeys = null
			var locationids = [];
			if (locgri != null && locgri != "") {
				peerGroupLocationGridKeys = locgri.getSelectedObjects();
				ivhTreeviewBfs(peerGroupLocationGridKeys, opts, function(node) {
					if (!node.children) {
						if (locationids.indexOf(node.id) == -1) {
							locationids.push(node.id);
						}
					}
				});

			}
			return locationids.toString();

		}
		// SME Date Range

		// SME Scale
		$scope.slider = {
			minValue : 'SME 1',
			maxValue : 'SME 8',
			options : {
				showTicksValues : true,
				stepsArray : [ {
					value : 'SME 1',
					legend : 'SME 1'
				}, {
					value : 'SME 2',
					legend : 'SME 2'
				}, {
					value : 'SME 3',
					legend : 'SME 3'
				}, {
					value : 'SME 4',
					legend : 'SME 4'
				}, {
					value : 'SME 5',
					legend : 'SME 5'
				}, {
					value : 'SME 6',
					legend : 'SME 6'
				}, {
					value : 'SME 7',
					legend : 'SME 7'
				}, {
					value : 'SME 8',
					legend : 'SME 8'
				} ],
				showSelectionBar : true
			}
		};

		/*
		 * function refreshSlider() { $timeout(function() {
		 * $scope.$broadcast('reCalcViewDimensions'); }); }
		 */

		$scope.checkErrForSme = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();

			if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					/* $scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;*/
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
					//	$scope.fromDateTrue = true;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.smeExDataTemp = {};
		$scope.totCntForCrisilSMERating = 0;
		$scope.totFilCntForCrisilSMERating = 0;
		// SME filter Validation
		$scope.smeFilterValidation = function(flag) {

			$scope.checkErrForSme(vm.smefromDate, vm.smetoDate);

			if ($scope.slider.minValue != undefined
					&& $scope.slider.minValue != null
					&& (flag != 'Initial' && flag != 'Reset')) {//As On page load dont consider slider value
				$scope.sliderfromValue = $scope.slider.minValue;
			} else {
				$scope.sliderfromValue = '';
			}
			if ($scope.slider.maxValue != undefined
					&& $scope.slider.maxValue != null
					&& (flag != 'Initial' && flag != 'Reset')) {
				$scope.slidertoValue = $scope.slider.maxValue;
			} else {
				$scope.slidertoValue = '';
			}

			// for industry
			$scope.selectedIndustriesTemp = [];
			if ($scope.idStack.length == 0) {
				$scope.selectedIndustriesTemp = '';
			} else {
				$scope.selectedIndustriesTemp = $scope.idStack.map(function(
						element) {

					return "<" + String(element) + "<"
				})
			}

			$scope.location = $scope.getselectedKeysForLocation();

			// for SME Constitution details
			if (vm.selectedconstitutionData != undefined) {
				$scope.selectedconstitutionDataTemp = vm.selectedconstitutionData
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			// search SME search companies
			if (vm.smesearchCompanies == undefined)
				vm.smesearchCompanies = ' ';

			if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
				$scope.toDateData = vm.smetoDate;
				$scope.fromDateData = vm.smefromDate;
			} else {
				$scope.toDateData = '';
				$scope.fromDateData = '';
			}

			if ($scope.fromDateData == undefined) {
				$scope.fromDateData = '';
			}

			if ($scope.toDateData == undefined) {
				$scope.toDateData = '';

			}

			var searchText = '';
			searchText = "{'constitution' : '"
					+ $scope.selectedconstitutionDataTemp
					+ "', 'industries' : '" + $scope.selectedIndustriesTemp
					+ "', 'competitorId' : '" + $scope.competitorId
					+ "', 'fromDate' : '" + $scope.fromDateData
					+ "', 'toDate' : '" + $scope.toDateData
					+ "', 'companyName' : '" + vm.smesearchCompanies
					+ "','locationIds':'" + $scope.location
					+ "','scaleFromValue':'" + $scope.sliderfromValue
					+ "','scaleToValue':'" + $scope.slidertoValue
					+ "','product':'SME'}";
			searchText = searchText.replace(/\'/g, "\"");
			searchText = searchText.replace(/\</g, "\'");

			$scope.smeExDataTemp = searchText;

			RatingListService
					.getCrisilSMERatingsList(searchText)
					.then(
							function(data) {
								$scope.crisilSMERatingList = data.CrisilSmeNsicRatingList[1];
								$scope.crisilSMERatingTotalCount = data.CrisilSmeNsicRatingList[2];
								$scope.smeUniqueCount = data.CrisilSmeNsicRatingList[3];

								$scope.totCntForCrisilSMERating = data.CrisilSmeNsicRatingList[2];
								$scope.totFilCntForCrisilSMERating = $scope.crisilSMERatingList.length;

								$scope.crisilSMEGridData = {
									dataProvider : $scope.crisilSMERatingList,
									delegate : $scope
								}
								$timeout(
										function() {
											$scope.crisilSMEGrid
													.setPreservePager(true);
											$scope.crisilSMEGrid
													.setDataProvider($scope.crisilSMERatingList);
											if ($scope.crisilSMERatingList.length > 0) {
												$scope.crisilSMEGrid
														.setTotalRecords($scope.crisilSMERatingTotalCount);
											} else {
												$scope.crisilSMEGrid
														.setTotalRecords(0);
											}
											$scope.crisilSMEGrid.validateNow();
											$scope.crisilSMEGrid.rebuild();
										}, 100);
							}, function(errordata) {
								$scope.crisilSMEGrid.setPageIndex(0);
							});

		}

		$scope.crisilSMEGridCompletion = function(event) {
			$scope.crisilSMEGrid = event.target;

			$scope.crisilSMEGrid.setPreservePager(true);
			$scope.crisilSMEGrid.setDataProvider($scope.crisilSMERatingList);
			if ($scope.crisilSMERatingList.length > 0) {
				$scope.crisilSMEGrid
						.setTotalRecords($scope.crisilSMERatingTotalCount);
			} else {
				$scope.crisilSMEGrid.setTotalRecords(0);
			}

			$scope.crisilSMEGrid.validateNow();
		};

		$scope.filterPageSortChangeHandlerSMERatingList = function(evt1) {

			var grid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.smeExDataTemp,
				typeOfRatingList : 'SME_RatingList',
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};
			if (filter.sortColumn == "SetOrRemoveAlert") {
				return;
			}
			baseRequest('api/ratingList/getFilterServerSidePagination', filter)
					.then(
							function(response) {

								grid.setPreservePager(true);
								grid
										.setDataProvider(response.data.typeOfRatingList);
								$scope.crisilSMEPaginationList = response.data.typeOfRatingList;
								if ($scope.crisilSMEPaginationList.length > 0) {
									$scope.crisilSMERatingTotalPaginationCount = response.data.totalCountOfList;
									grid
											.setTotalRecords($scope.crisilSMERatingTotalPaginationCount);
								} else {
									grid.setTotalRecords(0);
								}
								grid.validateNow();

							});

		}

		$scope.refreshSMEfilter = function() {
			$scope.selectAllind(false);
			$scope.selectAllloc(false);
			$scope.loccnt = 0;
			vm.smetoDate = '';
			vm.smefromDate = '';
			vm.smesearchCompanies = ' ';
			vm.selectedconstitutionData = [];
			$scope.totCntForCrisilSMERating = 0;
			$scope.totFilCntForCrisilSMERating = 0;
			$scope.slider.minValue = 'SME 1';
			$scope.slider.maxValue = 'SME 8';
		}
		$scope.resetSmeFilter = function() {

			$scope.selectAllind(false);
			$scope.selectAllloc(false);
			vm.smetoDate = '';
			vm.smefromDate = '';
			vm.smesearchCompanies = ' ';
			vm.selectedconstitutionData = [];
			$scope.totCntForCrisilSMERating = 0;
			$scope.totFilCntForCrisilSMERating = 0;
			$scope.slider.minValue = 'SME 1';
			$scope.slider.maxValue = 'SME 8';
			$scope.smeFilterValidation("Reset");
			$timeout(function() {
				// $scope.crisilSMEGrid.setPageIndex(0);
			}, 100);
		}

		// for NSIC RatingList
		// /search by name for NSIC
		$scope.searchFilterForNSICRatingList = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a compnay
			if (typedthings == "cleanData") {
				$scope.smecompanies = null;
			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings,
								"NSICRatingList")
						.then(
								function(data) {
									$scope.nsiccompanies = data;

									if ($scope.nsiccompanies.length == 0) {
										AlertService
												.error("Please search the appropriate company!");
									}
								},
								function(errordata) {
									AlertService
											.error("Error while searching company!");
								});
			}

		}

		// NSIC industry

		$scope.ind = {
			indstatus : false
		};
		$scope.ind.indstatus = false;
		var cnt = 0;

		$scope.setNSICIndustryTree = function() {

			$scope.ind.indstatus = true;
			// $scope.showResult = false;

			$scope.nsicgridOptionsSec = {
				dataProvider : $scope.sampleIndustrydata,
				delegate : $scope
			};

			if (cnt == 0) {
				cnt = 1;
				$timeout(function() {
					var l = document.getElementById('nsicIndustryButton');
					l.click();
				}, 100, false);

			}
			//$scope.selectAllind(true);
		}

		// for Location
		$scope.loccnt = 0;
		$scope.setNsicLocationTree = function() {
			$('#gridIndTreeData2' + $scope.name).hide();
			// $scope.loc.locstatus = true;
			$scope.showResult = false;

			$scope.nsicgridOptionsSecLoc = {
				dataProvider : $scope.sampletreedata,
				delegate : $scope
			};

			if ($scope.loccnt == 0) {
				$scope.loccnt = 1;
				$timeout(function() {
					var l = document.getElementById('locationButton_'
							+ $scope.name);
					l.click();
				}, 100, false);
			}
			//$scope.selectAllloc(true);
		}

		function getLocationTree() {

			var promise = GenericService.getZonalLocationDetailsdata();
			promise.then(function(data) {
				$scope.sampletreedata = data;

				$scope.nsicgridOptionsSecLoc = {
					dataProvider : $scope.sampletreedata,
					delegate : $scope
				};

			}, function(response, status, headers, config) {
				ErrorHandlerService.handleError(response, status, headers,
						config);
			});
		}

		$scope.checkErrForNsic = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;
			var curDate = new Date();

			if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					//   $scope.errMessage = 'todate should be greater than fromDate';
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
					//$scope.fromDateTrue = true;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.selectedconstitutionTemp = [];
		$scope.selectedIndustriesData = [];
		$scope.nsicExportTemp = {};
		$scope.totCntForNSICRatingList = 0;
		$scope.totFilCntNSICRatingList = 0;

		$scope.CrisilNSICRatingListCount = [];
		// for NSIC Filter Validation
		$scope.nsicFilterValidation = function() {

			$scope.checkErrForNsic(vm.nsicfromDate, vm.nsictoDate);
			// for location
			$scope.locationTemp = $scope.getselectedKeysForLocation();

			// for industry
			if ($scope.idStack.length == 0) {
				$scope.selectedIndustriesData = '';
			} else {
				$scope.selectedIndustriesData = $scope.idStack.map(function(
						element) {

					return "<" + String(element) + "<"
				})
			}

			// for NSIC Constitution details
			if (vm.nsicconstitutionData != undefined) {
				$scope.selectedconstitutionTemp = vm.nsicconstitutionData
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			// search NSIC search companies
			if (vm.nsicsearchCompanies == undefined)
				vm.nsicsearchCompanies = ' ';

			if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
				$scope.fromDateNsicTemp = vm.nsicfromDate;
				$scope.toDateNsicTemp = vm.nsictoDate;
			} else {
				$scope.fromDateNsicTemp = '';
				$scope.toDateNsicTemp = '';
			}

			if ($scope.toDateNsicTemp == undefined) {
				$scope.fromDateNsicTemp = '';
			}
			if ($scope.toDateNsicTemp == undefined) {
				$scope.fromDateNsicTemp = '';
			}

			if ($scope.nsicScaleGrid == undefined) {
				$scope.nsicScaleGrid = '';
			}

			var nsicInput = '';

			nsicInput = "{'constitution' : '" + $scope.selectedconstitutionTemp
					+ "', 'industries' : '" + $scope.selectedIndustriesData
					+ "', 'competitorId' : '" + $scope.competitorId
					+ "', 'fromDate' : '" + $scope.fromDateNsicTemp
					+ "', 'toDate' : '" + $scope.toDateNsicTemp
					+ "', 'companyName' : '" + vm.nsicsearchCompanies
					+ "', 'scale' : '" + $scope.nsicScaleGridList
					+ "','locationIds':'" + $scope.locationTemp
					+ "','product':'NSIC'}";
			nsicInput = nsicInput.replace(/\'/g, "\"");
			nsicInput = nsicInput.replace(/\</g, "\'");

			$scope.nsicExportTemp = nsicInput;

			RatingListService
					.getCrisilNSICRatingsList(nsicInput)
					.then(
							function(result) {
								$scope.CrisilNSICRatingList = result.CrisilSmeNsicRatingList[1];
								$scope.CrisilNSICRatingListCount = result.CrisilSmeNsicRatingList[2];
								$scope.nsicUniqueCount = result.CrisilSmeNsicRatingList[3];

								$scope.totCntForNSICRatingList = result.CrisilSmeNsicRatingList[2];
								$scope.totFilCntNSICRatingList = $scope.CrisilNSICRatingList.length;

								$scope.crisilNSICGridData = {
									dataProvider : $scope.CrisilNSICRatingList,
									delegate : $scope
								}

								$timeout(
										function() {
											$scope.crisilNSICGrid
													.setPreservePager(true);
											$scope.crisilNSICGrid
													.setDataProvider($scope.CrisilNSICRatingList);
											if ($scope.CrisilNSICRatingList.length > 0) {
												$scope.crisilNSICGrid
														.setTotalRecords($scope.CrisilNSICRatingListCount);
											} else {
												$scope.crisilNSICGrid
														.setTotalRecords(0);
											}

											$scope.crisilNSICGrid.validateNow();
											$scope.crisilNSICGrid.rebuild();
										}, 100);
								$scope.CrisilCreditRatingsListFilter = inputData;
							}, function(errordata) {
								// message = "Something went wrong, please try
								// again in
								// some time. If the problem persists, please
								// contact
								// Administrator.";
							});

		}
		$scope.crisilNSICGrid = '';
		$scope.CrisilNSICRatingListCount = [];
		$scope.crisilNSICGridCompletion = function(event) {
			$scope.crisilNSICGrid = event.target;
			$scope.crisilNSICGrid.setPreservePager(true);
			$scope.crisilNSICGrid.setDataProvider($scope.CrisilNSICRatingList);
			if ($scope.CrisilNSICRatingList.length > 0) {
				$scope.crisilNSICGrid
						.setTotalRecords($scope.CrisilNSICRatingListCount);
			} else {
				$scope.crisilNSICGrid.setTotalRecords(0);
			}
			$scope.crisilNSICGrid.validateNow();
		};

		$scope.filterPageSortChangeHandlerNSICRatingList = function(evt1) {

			var grid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.nsicExportTemp,
				typeOfRatingList : 'NSIC_RatingList',
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};

			if (filter.sortColumn == "SetOrRemoveAlert") {
				return;
			}

			baseRequest('api/ratingList/getFilterServerSidePagination', filter)
					.then(
							function(response) {
								grid.setPreservePager(true);
								grid
										.setDataProvider(response.data.typeOfRatingList);
								$scope.CrisilNSICPaginationList = response.data.typeOfRatingList;
								if ($scope.CrisilNSICPaginationList.length > 0) {
									$scope.crisilNSICRatingTotalPaginationCount = response.data.totalCountOfList;
									grid
											.setTotalRecords($scope.crisilNSICRatingTotalPaginationCount);
								} else {
									grid.setTotalRecords(0);
								}
								grid.validateNow();

							});

		}

		$scope.refreshNsicFilter = function() {
			$scope.selectAllind(false);
			$scope.selectAllloc(false);
			idss = new Array();
			vm.nsicsearchCompanies = ' ';
			vm.nsicconstitutionData = [];
			vm.nsictoDate = '';
			vm.nsicfromDate = '';
			$scope.totCntForNSICRatingList = 0;
			$scope.totFilCntNSICRatingList = 0;
			$scope.nsicScaleGrid = '';
			$scope.nsicScaleGridList = [];
			$timeout(function() {
				//	$scope.crisilNSICGrid.setPageIndex(0);
			}, 100);

		}
		$scope.resetNsicFilter = function() {
			vm.nsicsearchCompanies = ' ';
			vm.nsicconstitutionData = [];
			vm.nsictoDate = '';
			vm.nsicfromDate = '';
			$scope.selectAllind(false);
			$scope.selectAllloc(false);
			$scope.totCntForNSICRatingList = 0;
			$scope.totFilCntNSICRatingList = 0;
			$scope.nsicScaleGrid = '';
			$scope.nsicScaleGridList = [];
			$scope.nsicFilterValidation();
			$scope.checkButtons = false;
			for (var i = 0; i < $scope.nsicScaleGridIDList.length; i++) {
				var myEl = angular.element(document.querySelector('#'
						+ $scope.nsicScaleGridIDList[i]));
				myEl.toggleClass('btnactive');
			}
			$scope.nsicScaleGridIDList = [];
			$timeout(function() {
				//	$scope.crisilNSICGrid.setPageIndex(0);
			}, 100);

		}
		// $scope.selectAllind(true);

		// Start Export Excel for All Rating Tabs

		//NSIC Rating Export Excel;
		var nsicExData = '';
		$scope.ifError = false;
		$scope.nsicexport = function() {
			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {
				$scope.exportInputDTO = {
					competitorId : $scope.competitorId,
					ratingInput : $scope.nsicExportTemp + ""
				};

				$http({
					url : 'api/ratingList/nsicRatingExcelExportData',
					method : 'POST',
					data : $scope.exportInputDTO,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'NSIC Ratings.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'NSIC Ratings.xlsx'
										})[0].click();

										anchor.remove();

									}

								})

			}
		}
		//SF Export Excel
		var sfExData = '';
		$scope.sfRatingExport = function() {
			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {
				$scope.exportInputDTO = {
					competitorId : $scope.competitorId,
					ratingInput : $scope.sfExDataTemp + ""
				};
				//sfExData = $scope.sfExDataTemp;
				//data : sfExData,
				$http({
					url : 'api/ratingList/sfRatingExcelExportData',
					method : 'POST',
					data : $scope.exportInputDTO,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {

									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'SF Ratings.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'SF Ratings.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
			}
		}
		//SME Rating Export Excel
		var smeExData = '';
		$scope.smeRatingExport = function() {
			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {
				$scope.exportInputDTO = {
					competitorId : $scope.competitorId,
					ratingInput : $scope.smeExDataTemp + ""
				};

				//smeExData = $scope.smeExDataTemp;
				$http({
					url : 'api/ratingList/smeRatingExcelExportData',
					method : 'POST',
					data : $scope.exportInputDTO,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'SME Ratings.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'SME Ratings.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
			}
		}

		//credit Rating Export Excel
		var creditRatingInput = '';
		$scope.creditRatingExport = function() {

			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {

				$scope.exportInputDTO = {
					competitorId : $scope.competitorId,
					ratingInput : $scope.inputDataTemp + ""
				};

				//creditRatingInput = $scope.inputDataTemp;
				$http({
					url : 'api/ratingList/creditRatingExcelExportData',
					method : 'POST',
					data : $scope.exportInputDTO,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {

									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'Credit Ratings.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'Credit Ratings.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
			}

		}

		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.startMaxDate = new Date();
		$scope.endMaxDate = new Date();

		$scope.popup1 = {
			opened : false
		};
		$scope.popup2 = {
			opened : false
		};

		$scope.open1 = function($event) {
			$scope.popup1.opened = true;
			$scope.enableNewlyAdded = true;
		};
		$scope.open2 = function($event) {
			$scope.popup2.opened = true;
			$scope.enableNewlyAdded = true;
		};
		// for sme Date Range
		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};

		// for Nsic Date Range
		$scope.popup5 = {
			opened : false
		};
		$scope.popup6 = {
			opened : false
		};
		$scope.open5 = function($event) {
			$scope.popup5.opened = true;
		};
		$scope.open6 = function($event) {
			$scope.popup6.opened = true;
		};

		$scope.dateOptions = {
			formatYear : 'yy',
			startingDay : 1
		};

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];

		$scope.$watch('fromDate', function() {

			if (!$scope.fromDate) {
				return;
			}
			if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
				$scope.endMaxDate = new Date();
			} else {
				$scope.startMaxDate = $scope.fromDate;
			}
			$scope.fromDate = $scope.fromDate;

		});

		$scope.$watch('misReport.toDate', function() {

			if (!$scope.toDate) {
				return;
			}
			if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
				// $scope.endMaxDate = $scope.misReport.toDate;
			} else {
				$scope.startMaxDate = $scope.toDate;
			}
			$scope.toDate = $scope.toDate;
		});

		// Set Alert For All
		$scope.setAlertForAll = function(filterType) {
			var filter = '';
			var ratingType = 'CREDIT';
			if (filterType == 'CREDIT') {
				filter = $scope.inputDataTemp;
				ratingType = 'CREDIT';

			} else if (filterType == 'SME') {
				filter = $scope.smeExDataTemp;
				ratingType = "SME";
			} else if (filterType == 'NSIC') {

				filter = $scope.nsicExportTemp;
				ratingType = "NSIC";

			} else if (filterType == 'INSTRUMENTISIN') {

				filter = $scope.inputInstrumentsIsinDataTemp;
				ratingType = 'INSTRUMENTISIN';
			} else if (filterType == 'SF') {

				filter = $scope.sfExDataTemp;
				ratingType = 'SF';
			}

			var companyDataDto = {
				companyCode : '',
				industryId : '',
				portFolioId : '',
				isIndustryLevel : 'N',
				isPortfolioLevel : 'N',
				isCompanyLevel : 'N',
				isRatingList : 'Y',
				isInstrumentalType : filterType,
				portfolioFilter : filter,
				ratingDetailType : ratingType

			};
			$uibModal
					.open({

						templateUrl : 'app/alert components/set alert/companyLevelAlert.html',
						controller : 'CompanyLevelAlert',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							companyData : function() {
								return companyDataDto;
							},
							controllerModule : function() {
								return 'RatingListController';
							},
							parentAccess : function() {
								return $scope;
							},
							isSelectAll : function() {
								return true;
							}

						}
					}).closed.then(function() {

			});
		}

		//for getOthersRatingsList

		$scope.getOtherRatingData = function() {
			$scope.otherRatingMasterData = [];

			RatingListService
					.getOtherRatingsType()
					.then(
							function(data) {
								$scope.otherRatingMasterData = data;
								$scope
										.getOthersRatingsList($scope.otherRatingMasterData[0].id);
								$scope.selectedRatingData = $scope.otherRatingMasterData[0];
							}, function(errordata) {

							});

		}

		var searchRating = '';
		$scope.showRatingAgencyCol = false; // nikhil
		$scope.showRatingOthers = true;
		$scope.fundFlag = false; //nikhil
		$scope.showRatingColumn = false; // for removing rating column into real estate
		$scope.sfRatingFlag = false;
		$scope.getOthersRatingsList = function(selectedRating) {

			if (selectedRating == undefined || selectedRating == '') {
				$scope.selectedRatingTemp = '';
			} else {
				$scope.selectedRatingTemp = selectedRating;
			}
			// code added by Nikhil 
			if (selectedRating == "Mutual Fund") {
				$scope.fundFlag = true;
				$scope.showRatingAgencyCol = true;
				$scope.showRatingOthers = false;
				$scope.sfRatingFlag = false;
				$scope.selectedRatingId = selectedRating;
				$scope.selectedfundRatingAgencyId = vm.selectedfundRatingAgencyType
						.map(function(element) {
							return "<" + String(element.labelName) + "<"
						})

				searchRating = "{'product' : '" + $scope.selectedRatingTemp
						+ "','ratingAgencyId' : '"
						+ $scope.selectedfundRatingAgencyId + "'}";

			} else if (selectedRating == "Structure Finance") {
				$scope.sfRatingFlag = true;
				$scope.fundFlag = false;
				$scope.showRatingAgencyCol = false;
				$scope.showRatingOthers = false;

				$scope.sfresetFilter();

			} else {
				$scope.fundFlag = false;
				$scope.showRatingAgencyCol = false;
				$scope.showRatingOthers = true;
				$scope.refershFundRatingAgencyDD();
				$scope.sfRatingFlag = false;

				searchRating = "{'product' : '" + $scope.selectedRatingTemp
						+ "'}";
			}

			searchRating = searchRating.replace(/\'/g, "\"");
			searchRating = searchRating.replace(/\</g, "\'");

			// code end here
			RatingListService.getOthersRatingsList(searchRating).then(
					function(data) {
						$scope.otherRatingResultList = data.OtherRatingList[0];

						//$scope.otherRatingResultList = data;
						$scope.otherRatingGridData = {
							//change here for funding and other.
							dataProvider : $scope.otherRatingResultList,
							delegate : $scope
						}

						if ($scope.selectedRatingId == "Mutual Fund"
								&& $scope.selectedfundRatingAgencyId == "") {

							$scope.refershFundRatingAgencyDD();
						}

					}, function(errordata) {

					});

		}

		var otherRatingGrid = '';
		$scope.otherRatingGridCompletion = function(event) {
			otherRatingGrid = event.target;
			otherRatingGrid.validateNow();

		}

		// RRDOC for OtherRatings
		$scope.getOtherHrefData = function(item, column) {
			if (item.ratingAgency == 'CRISIL Ratings Limited') {

				return ('<div><a onClick=openOtherRatingRRANDCRRDOC(this,"RRDOC") id="'
						+ item.fileNameForRRDOC
						+ '" name='
						+ '  "'
						+ item.companyName
						+ '"'
						+ '>'
						+ item.dateOfRatingAssigned + '</a></div>');
			} else {

				return ('<div><span id=' + item.fileNameForRRDOC + ' name='
						+ '  "' + item.companyName + '"' + '>'
						+ item.dateOfRatingAssigned + '</span></div>')
			}
		}

		//Href for RR and CRR in OtherRating Tab
		$window.openOtherRatingRRANDCRRDOC = function(item, itemType) {
			$scope.redirectToRRDOCDetails(item, itemType)
		}

		// Reading RRDOC and CRRDOC form companyProfile for otherRatings
		$scope.alertForOtherRating = true;
		$scope.redirectToRRDOCDetails = function(item, itemType) {

			var fileNameForCRRDOC = item.id;
			$scope.fileNameForDownload = fileNameForCRRDOC;
			$scope.reportTypeForDownload = itemType;
			var type = '';
			var companyNameForOthers = item.name;
			var fd = new FormData();
			fd.append('fileName', fileNameForCRRDOC);
			fd.append('docType', itemType);
			fd.append('companyName', companyNameForOthers);
			fd.append('userDoc', '');
			var uploadUrl = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var filext = fileNameForCRRDOC.substring(fileNameForCRRDOC
					.lastIndexOf(".") + 1);
			if (filext == 'pdf' && filext != '') {
				jQuery('#otherDocumentPopUp').show();
				jQuery('#otherDocumentPathForm').show();
				jQuery('#otherDocumentHTMLPath').hide()
				jQuery('#fileNameHiddenRRCrrOther').val(fileNameForCRRDOC);
				jQuery('#documentTypeHiddenOther').val(itemType);
				jQuery('#companyNameTypeHiddenOther').val(companyNameForOthers);
				jQuery('#userDocOther').val($scope.userId);
				jQuery('#otherDocumentPathForm').submit();
				jQuery('#otherDocumentPopUp').modal({
					show : 'false'
				});

			} else {
				$http.post(uploadUrl, fd, {
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined,
					}
				}).success(
						function(response) {
							jQuery('#otherDocumentPopUp').hide();
							jQuery('#otherDocumentPathForm').hide();
							jQuery('#otherDocumentHTMLPath').show()
							jQuery('#otherDocumentHTMLPath').contents().find(
									'body').html(response);
							jQuery('#otherDocumentPopUp').modal({
								show : 'false'
							});
						}).error(function(response, status, headers, config) {

				});
			}

		}

		//Add to Portfolio company wise

		$scope.AddToPortfolioPopUp = function(data) {
			if (!$scope.userModuleAccessData["Portfolio View"]
					&& !$scope.userModuleAccessData["Portfolio Compare"]
					&& !$scope.userModuleAccessData["Create Portfolio"]) {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 5000);
			} else {

				if (data.setOrRemoveAlert == 0) {
					$scope.setStatus = false;
				}
				$uibModal
						.open({
							templateUrl : 'app/components/addToPortfolio/addToPortfolio-dialog.html',
							controller : 'AddToPortfolioDialogController',
							controllerAs : 'vm',
							size : 'lg',
							resolve : {
								companyName : function() {
									return data.companyName;
								},
								companyCode : function() {
									return data.companyCode;
								},
								parentAccess : function() {
									return $scope;
								},
								controllerModule : function() {
									return 'RatingListController';
								}
							}
						}).closed.then(function() {

					if ($scope.setStatus) {
						data.setOrRemoveAlert = 1;
						$timeout(function() {
							if ($scope.currentbstId == 1) {
								$scope.getCrisilCreditRatingsList();
							} else if ($scope.currentbstId == 3) {
								$scope.smeFilterValidation();
							} else if ($scope.currentbstId == 4) {
								$scope.nsicFilterValidation();
							} else if ($scope.currentbstId == 7) {

								$scope.instruIsinGrid.validateNow();
								$scope.instruIsinGrid.rebuild();
								//								//	$scope.getInstrumentsISIN();
							}

						}, 100);

						$scope.setStatus = false;
					}
				});
			}
		}
		$scope.openAddToPortfolioPopUp = function(row, column) {
			var html = '';
			if (row.addPortfolio) {
				html = '<a class="search" onClick= "AddToPortfolio(this)"><i class="fa fa-briefcase briefcase-align"></i></a>';
			}

			return html;
		};

		$window.AddToPortfolio = function(item) {

			$scope.AddToPortfolioPopUp(item.parentNode.component.data);

		}
		// Add All Companies to new Portfolio OR existing portfolio
		$scope.addAllToPortfolio = function() {
			if (!$scope.userModuleAccessData["Portfolio View"]
					&& !$scope.userModuleAccessData["Portfolio Compare"]
					&& !$scope.userModuleAccessData["Create Portfolio"]) {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 5000);
			} else {
				$scope.flag = 'new';
				$('#addAllToPortfoliomodal').modal('show');
			}
		}

		//success message
		$scope.successMessages = '';
		function showSuccess(message) {
			$scope.ifsuccess = true;
			$scope.successMessages = message;
			$timeout(function() {
				$scope.ifsuccess = false;
				$scope.successMessages = '';
			}, 10000);
		}
		//error message
		function showError(message) {
			$scope.ifError = true;
			$scope.errorMessages = message;
			$timeout(function() {
				$scope.ifError = false;
				$scope.errorMessages = '';
			}, 10000);
		}

		$scope.flag = {};
		$scope.selectedValue = function() {
			if ($scope.flag == 'new') {
				$scope.selectedPortfolio.inputName = '';
			} else if ($scope.flag == 'existing') {
				vm.portfolioName = '';
			}
		}

		//AddAllPortfolio 
		$scope.selectedPortfolio = {};
		$scope.saveAllCompanies = function(selectedData) {

			if (selectedData == 'new') {
				$scope.portfolioName = vm.portfolioName;

				if ($scope.portfolioName == null || $scope.portfolioName === '') {
					alert('Please enter portfolio name.')
					return false;
				}

				PortfolioService
						.validatePortfolioName($scope.portfolioName)
						.then(
								function(result) {
									if (result[0].length > 0) {
										var error = result[0] + '';
										showError(error)
										return false;
									} else {

										var companyData = $scope.totalUniqueCompanyCodes;

										$scope.inputData = {
											id : null,
											name : $scope.portfolioName,
											uploadFlag : 'N',
											isDeleted : 'N',
											//  addAllCompanyList : companyData,
											isShared : 'Y',
											creditInput : $scope.inputDataTemp
										}

										RatingListService
												.addAllToPortfolio(
														$scope.inputData)
												.then(
														function(data) {
															var message = 'Portfolio created successfully. Changes will be refelected after 15-20 minutes in dashboard.';
															$scope.portfolioName = '';
															$(window)
																	.scrollTop(
																			0);
															// $scope.resetFilter();
															showSuccess(message);
															$scope.close();
														},
														function(error) {

															$scope.close();
															var err = error.data.message;
															$(window)
																	.scrollTop(
																			0);
															showError(err);

														});

									}
								}, function(error) {
									$(window).scrollTop(0);
									var err = error.data.message;
									showError(err);

								});

			} else if (selectedData == 'existing') {
				if ($scope.selectedPortfolio.isAlertSet == 'Y') {
					$('#addAllPortfolioRemoveAlertModal').modal('show');
				} else {
					$scope.addAllToPortfolioWithConfirmation(false);
				}
			}

		}

		$scope.addAllToPortfolioWithConfirmation = function(addRemoveAlert) {
			$('#addAllPortfolioRemoveAlertModal').modal('hide');

			$scope.existingPortfolioName = $scope.selectedPortfolio.inputName;
			$scope.updatedPortfolioId = $scope.selectedPortfolio.inputValue;

			// for existing portfolio name

			if ($scope.existingPortfolioName != null
					&& $scope.existingPortfolioName != undefined) {
				//  var companyData = $scope.totalUniqueCompanyCodes;

				$scope.inputData = {
					id : $scope.updatedPortfolioId,
					name : $scope.existingPortfolioName,
					uploadFlag : 'N',
					isDeleted : 'N',
					addRemoveAlert : addRemoveAlert,
					//  addAllCompanyList : companyData,
					isShared : 'Y',
					creditInput : $scope.inputDataTemp
				}

				RatingListService
						.addAllToPortfolio($scope.inputData)
						.then(
								function(data) {
									var message = 'Companies have been added successfully in Portfolio.';
									$scope.portfolioName = '';
									$(window).scrollTop(0);
									showSuccess(message);
									$scope.close();

									if (addRemoveAlert) {
										$timeout(
												function() {
													if ($scope.currentbstId == 1) {
														$scope
																.getCrisilCreditRatingsList();
													} else if ($scope.currentbstId == 3) {
														$scope
																.smeFilterValidation();
													} else if ($scope.currentbstId == 4) {
														$scope
																.nsicFilterValidation();
													} else if ($scope.currentbstId == 7) {

														$scope.instruIsinGrid
																.validateNow();
														$scope.instruIsinGrid
																.rebuild();
														//	                    								//	$scope.getInstrumentsISIN();
													}

												}, 100);
									}
								}, function(error) {
									$scope.close();
									var err = error.data.message;
									$(window).scrollTop(0);
									showError(err);
								});

			}

		}

		$scope.close = function() {
			$('#addAllToPortfoliomodal').modal('hide');
			$scope.iferrorPopup = false;
			$scope.errorMessages = '';
			$scope.selectedPortfolio.inputName = '';
			vm.portfolioName = '';
			$scope.getExistingPortfolios();

		}

		//getting Existing portfolios

		$scope.getExistingPortfolios = function() {

			$http.post('api/portfolio/getSelectedType').success(function(data) {
				$scope.userportfoliolist = data;
				$scope.selectedportfolio = $scope.userportfoliolist;

			});
		}

		$scope.getConsolidatedFileName = '';

		$scope.getConsolidatedFile = function() {

			RatingListService.getConsolidatedFile().then(function(data) {
				$scope.getConsolidatedFileName = data.fileName;
			}, function(errordata) {
			});

		}

		// code start here by Nikhil Nale
		$scope.forRatingAgencyCode = function() {
			$scope.getOthersRatingsList($scope.selectedRatingId);

		}

		$scope.refershFundRatingAgencyDD = function() {

			$scope.ratingAgencySelectedMod = $scope.ratingAgencyData[1].name;
			vm.selectedfundRatingAgencyType = [];
			vm.selectedfundRatingAgencyType = [ {
				"id" : 6,
				"name" : "CRISIL Ratings Limited",
				"labelName" : "CRISIL",
				"chekced" : true
			} ];

		}

		$scope.durationforNewlyAdded = function(durationData) {

			if (durationData) {
				$scope.newlytemp = true;
				$scope.selectedDurationForNewlyAddedTemp = 'newlyAddedCompanies';
			} else {
				$scope.newlytemp = false;
				$scope.selectedDurationForNewlyAddedTemp = '';
			}
			$scope.showData = true;

		}

		$scope.getOtherRatingHrefData = function(item, column) {
			if (JSON.stringify(item).includes('CRISIL')) {
				return ('<div><a onClick=openOtherRatingRRANDCRRDOC(this,"RRDOC") id='
						+ item.fileNameForRRDOC
						+ '>'
						+ item.lastRatingActionDate + '</a></div>');
			}
			return ('<div><span id=' + item.fileNameForRRDOC + '>'
					+ item.lastRatingActionDate + '</span></div>');

		}

		$scope.refreshInstrumentsIsin = function() {

			vm.searchCompaniesForIsin = ' ';

			angular.forEach($scope.ratingAgencyData, function(val, key) {

				val.chekced = true;

			});

			$scope.selectAll.checked = true;
			$scope.innertbstId = 14;

			$scope.getInstrumentsISIN();

		}

		$scope.getInstrumentsISIN = function() {
			var instrumentsISINData = '';

			$scope.searchCompanyForISIN = vm.searchCompaniesForIsin;

			if ($scope.ratingAgencyData != undefined) {
				$scope.selectedratingagenciesForISIN = [];

				var k = 0;
				for (var j = 0; j < $scope.ratingAgencyData.length; j++) {
					if ($scope.ratingAgencyData[j].chekced) {
						k++;
					}

				}
				if (k == 0) {
					for ( var i in $scope.ratingAgencyData) {
						if ($scope.ratingAgencyData[i].name == 'CRISIL Ratings Limited')
							$scope.ratingAgencyData[i].chekced = true;

					}
				}
				for ( var i in $scope.ratingAgencyData) {
					if ($scope.ratingAgencyData[i].chekced == true) {

						$scope.selectedratingagenciesForISIN
								.push($scope.ratingAgencyData[i]);
					}
				}

				$scope.selectedratingagenciesTemp = $scope.selectedratingagenciesForISIN
						.map(function(element) {
							return "<" + String(element.labelName) + "<"
						})
			}

			instrumentsISINData = "{'ratingAgency' : '"
					+ $scope.selectedratingagenciesTemp
					+ "', 'nameOfCompany' : '" + $scope.searchCompanyForISIN
					+ "'}";
			instrumentsISINData = instrumentsISINData.replace(/\'/g, "\"");
			instrumentsISINData = instrumentsISINData.replace(/\</g, "\'");

			$scope.inputInstrumentsIsinDataTemp = instrumentsISINData;

			RatingListService
					.getInstrumentsISIN(instrumentsISINData)
					.then(
							function(data) {

								$scope.instrumentIsinResultList = data.instrumentsIsinResultList[0];
								$scope.instrumentIsinTotalCount = data.instrumentsIsinResultList[1];
								$scope.totalUniqueInstrumentCount = data.instrumentsIsinResultList[2];

								$scope.totalCountForCreditRating = data.instrumentsIsinResultList[1];

								$scope.instrumentIsinGridData = {
									dataProvider : $scope.instrumentIsinResultList,
									delegate : $scope
								}

								$timeout(
										function() {
											$scope.instruIsinGrid
													.setPreservePager(true);
											$scope.instruIsinGrid
													.setDataProvider($scope.instrumentIsinResultList);
											if ($scope.instrumentIsinResultList.length > 0) {
												$scope.instruIsinGrid
														.setTotalRecords($scope.instrumentIsinTotalCount);
											} else {
												$scope.instruIsinGrid
														.setTotalRecords(0);
											}

											$scope.instruIsinGrid.validateNow();
											$scope.instruIsinGrid.rebuild();
										}, 100);

							}, function(errordata) {

							});

		}

		// code html tree grid

		$scope.instruIsinGridCompletion = function(event) {
			$scope.instruIsinGrid = event.target;
			$scope.instruIsinGrid.setPreservePager(true);
			$scope.instruIsinGrid
					.setDataProvider($scope.instrumentIsinResultList);
			if ($scope.instrumentIsinResultList.length > 0) {
				$scope.instruIsinGrid
						.setTotalRecords($scope.instrumentIsinTotalCount);

			} else {
				$scope.instruIsinGrid.setTotalRecords(0);
			}
			$scope.instruIsinGrid.validateNow();
		}

		// export instrument ISIN data

		$scope.instrumentIsinExport = function() {
			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {
				$scope.exportInputDTO = {
					competitorId : $scope.competitorId,
					ratingInput : $scope.inputInstrumentsIsinDataTemp + ""
				};

				$http({
					url : 'api/ratingList/instrumentsIsinExcelExportData',
					method : 'POST',
					data : $scope.exportInputDTO,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {

									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'ISIN.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'ISIN.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
			}
		}

		// server side pegination for Instrument ISIN

		$scope.filterPageSortChangeHandlerInstrumentIsinList = function(evt1) {
			var grid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.inputInstrumentsIsinDataTemp,
				typeOfRatingList : 'Instrument_ISIN',
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};

			baseRequest('api/ratingList/getFilterServerSidePagination', filter)
					.then(
							function(response) {
								grid.setPreservePager(true);
								grid
										.setDataProvider(response.data.typeOfRatingList);
								$scope.instrumentIsinPaginationList = response.data.typeOfRatingList;
								if ($scope.instrumentIsinPaginationList.length > 0) {
									$scope.InstrumentIsinTotalPaginationCount = response.data.totalCountOfList;
									grid
											.setTotalRecords($scope.InstrumentIsinTotalPaginationCount);
								} else {
									grid.setTotalRecords(0);
								}
								grid.validateNow();

							});

		}

		$scope.isuuerNonCoopeativeChange = function(issuerNon) {
			if (issuerNon) {
				$scope.issureNonCor = true;
				$scope.selectedIssuerNonCooperativeTemp = 'issuerNonCoopeartive';
			} else {
				$scope.issureNonCor = false;
				$scope.selectedIssuerNonCooperativeTemp = '';
			}
		}

		// code for issuer rating filter

		$scope.markAll2 = {
			check : false
		};

		$scope.changeRatingTypeForIssuerRating = function(markAll2, type) {

			if (type == 'issuerRating') {
				$scope.markAll.checked = false;
				$scope.markAll1.checked = false;

				angular.forEach($scope.ratingScaleShort, function(val, key) {
					val.chekced = false;
				});
				angular.forEach($scope.ratingScaleLong, function(val, key) {
					val.chekced = false;
				});

				$scope.enableMe = true;
				if (markAll2) {
					angular.forEach($scope.issuerTermLongRating, function(val,
							key) {
						val.check = true;
						// alert(val.chekced);
					});

					angular.forEach($scope.issuerRatingTermsRating, function(
							val, key) {
						val.check = true;
						// alert(val.chekced);
					});

				} else {
					$scope.issuerRatings = "";
					$scope.enableMe = false;
					angular.forEach($scope.issuerTermLongRating, function(val,
							key) {
						val.check = false;
					});

					angular.forEach($scope.issuerRatingTermsRating, function(
							val, key) {
						val.check = false;
					});
				}
			}

		}

		// disable long term and short term filter when user checked issuer rating
		$scope.disableFunc = function() {

			$scope.markAll.checked = false;
			$scope.markAll1.checked = false;

			angular.forEach($scope.ratingScaleShort, function(val, key) {
				val.chekced = false;
			});
			angular.forEach($scope.ratingScaleLong, function(val, key) {
				val.chekced = false;
			});

			for ( var i in $scope.issuerTermLongRating) {
				if ($scope.issuerTermLongRating[i].check == true) {
					$scope.flagOfissuerLongTerm = true;
					break;
				} else {

					$scope.flagOfissuerLongTerm = false;
				}
			}

			for ( var i in $scope.issuerRatingTermsRating) {
				if ($scope.issuerRatingTermsRating[i].check == true) {
					$scope.flagOfissuerShortTerm = true;
					break;
				} else {

					$scope.flagOfissuerShortTerm = false;
				}
			}

			if ($scope.flagOfissuerLongTerm || $scope.flagOfissuerShortTerm) {

				$scope.enableMe = true;
			} else {
				$scope.enableMe = false;
			}

		}

		$scope.downloadRRCRRReport = function() {
			var fileNames = $scope.fileNameForDownload;
			var documentTypess = $scope.reportTypeForDownload;
			var fd = new FormData();
			fd.append('fileName', fileNames);
			fd.append('docType', documentTypess);

			var uploadUrl = 'api/RRCRR/downloadPdf';
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				responseType : 'arraybuffer',
				headers : {
					'Content-Type' : undefined,
				}
			}).success(
					function(response) {

						var isIE = false || !!document.documentMode;
						$scope.response = response;
						var blob = new Blob([ response ], {
							type : 'application/octet-stream'
						});
						if (isIE) {

							window.navigator.msSaveOrOpenBlob(blob,
									$scope.fileNameForDownload);
						} else {

							var anchor = angular.element('<a/>');
							var blob = new Blob([ response ], {
								type : 'application/octet-stream'
							})
							var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
							anchor.css({
								display : 'none'
							});
							// Make sure it's not visible
							angular.element(document.body).append(anchor); // Attach to document
							anchor.attr({
								href : objectUrl,
								target : '_self',

								download : $scope.fileNameForDownload
							})[0].click();

							anchor.remove();

						}
						$scope.updateStatusForRRCRRReport(fileNames,
								documentTypess);

					})

		}

		$scope.updateStatusForRRCRRReport = function(fileNames, documentTypess) {

			var fd = new FormData();
			fd.append('fileName', fileNames);
			fd.append('docType', documentTypess);

			GenericService.updateDownloadStatusForRRCRRreport(fd);
		}

		$scope.checkErrForRatingAmount = function(fromRatingAmount,
				toRatingAmount) {

			$scope.fromRatingAmountFlag = false;
			$scope.toRatingAmountFlag = false;

			if (fromRatingAmount == undefined || fromRatingAmount == '') {

				$scope.fromRatingAmountFlag = false;
				$scope.toRatingAmountFlag = false;

				alert("from rating amount should not be blank");
				return false;

			} else if (toRatingAmount == undefined || toRatingAmount == '') {

				$scope.fromRatingAmountFlag = false;
				$scope.toRatingAmountFlag = false;

				alert("to rating amount should not be blank");
				return false;
			}

		}

		$scope.checkErrForAmounts = function(fromRatingAmount, toRatingAmount) {

			$scope.fromRatingAmountFlag = true;
			$scope.toRatingAmountFlag = true;

			if (parseInt(fromRatingAmount) > parseInt(toRatingAmount)) {

				$scope.fromRatingAmountFlag = true;
				$scope.toRatingAmountFlag = true;
				alert("from rating amount is not greater than to rating amount");
				return false;
			}
			return true;
		}
		// set alert code added for sf rating section

		$scope.portfsetOrRemoveCompanyAlertFlagSf = function(row, column) {
			var html = '';
			if (row.setOrRemoveAlert == 0) {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagSf(this)"><i class="fa fa-bell bell-align"></i></a>';
			} else {
				html = '<a class="search" onClick= "setOrRemoveCompanyAlertFlagSf(this)"><i class="fa fa-bell-slash bell-align"></i></a>';

			}

			return html;
		};

		$window.setOrRemoveCompanyAlertFlagSf = function(item) {

			$scope.setOrRemoveCompanyAlert(item.parentNode.component.data);

		}

		// export other rating data

		$scope.otherRatingExport = function() {
			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {

				var searchRating = "{'product' : '" + $scope.selectedRatingTemp
						+ "','ratingAgencyId' : '"
						+ $scope.selectedfundRatingAgencyId + "'}";

				searchRating = searchRating.replace(/\'/g, "\"");
				searchRating = searchRating.replace(/\</g, "\'");

				$http({
					url : 'api/ratingList/getOtherRatingsListExport',
					method : 'POST',
					data : searchRating,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {

									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'Other Rating.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'Other Rating.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
			}
		}
		
		
		//Task Id 147451
		
		// for instruments ISIN
		$scope.unacceptedRatingGrid = '';
		$scope.unacceptedRatingResultList = [];
		$scope.unaccptedRatingPaginationList = [];
		$scope.selectedListingType = [];
		vm.selectedAgenciesUnacceptedRating = '';
		
		$scope.refreshUnacceptedRating = function() {

			vm.unacceptedRatingComp = ' ';		
			vm.unacceptedfromDate = ''; 
			vm.unacceptedtoDate = '';
			vm.selectedScalesShortTerm = [];
			$scope.selectedScalesShortTermTemp = [];
			vm.selectedAgencies = [];
			$scope.selectedListingType = [];
			vm.selectedAgenciesUnacceptedRating = '';
			$scope.getUnacceptedRatingList();

		}
		
		$scope.selectedListingType = [];
		$scope.addListingType = function(cb, val) {
			if (cb.target.checked) {
				$scope.selectedListingType.push(val);
			} else {
				var idx = $scope.selectedListingType.indexOf(val);
				$scope.selectedListingType.splice(idx, 1);
			}

		}
		
		$scope.getRatingScalesData = function() {
			$scope.mergeArray = [];
			
			PortfolioService.getRatingScaleMasterList().then(function(data) {							
				$scope.ratingScaletype = data;
				var ratetype = [];
				angular.forEach(data, function(value, key) {

					var obj = {
							'name' : key,
							'msGroup' : true
						};
						ratetype.push(obj);
						$scope.ratingScaletype[key].map(function(row) {
							row.type = key;
							ratetype.push(row);
						});
						var objf = {

							'msGroup' : false
						};
						ratetype.push(objf);
					
				});
				$scope.mergeArray = ratetype;
				
			}, function(error) {
			});

		}
		
		$scope.checkErrForUnacceptedRating = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();

			if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {					
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
					//	$scope.fromDateTrue = true;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};
		
		$scope.disableOtherType = function(compo, isReset) {
			// filter selected Issuer rating into array
			var issuerRatingList = [];
			if (!isReset) {
				issuerRatingList = compo.filter(function(el) {
					return typeof el.symbol !== 'undefined'
							&& el.symbol.indexOf('IR ') > -1 && el.ticked;
				});
			}
			if (issuerRatingList.length > 0) {
				$.each(compo, function(key, value) {
					if (typeof value.symbol !== 'undefined'
							&& !(value.name == 'Issuer Rating' || value.symbol
									.indexOf('IR ') > -1)) {
						value.disabled = true;
						value.ticked = false;
					}
				});
			} else {
				$.each(compo, function(key, value) {
					value.disabled = false;
				});
			}
		}
		
		$scope.getUnacceptedRatingList = function() {
			
			$scope.checkErrForUnacceptedRating(vm.unacceptedfromDate, vm.unacceptedtoDate);
			
			$scope.selectedListingTypeTemp = [];
			if ($scope.selectedListingType.length > 0) {
				$scope.selectedListingTypeTemp = $scope.selectedListingType
						.map(function(element) {
							return "<" + String(element) + "<"
						})
			}
			
			var ratingType = [];
			$scope.ratingTypeValue = [];
			if (vm.selectedScalesShortTerm != undefined
					&& vm.selectedScalesShortTerm.length > 0) {
				$scope.selectedScalesShortTermTemp = vm.selectedScalesShortTerm
						.map(function(element) {

							if (ratingType.filter(function(x) {
								return x === element.type;
							}).length == 0) {
								ratingType.push(element.type);
							}
							return "<" + String(element.name) + "<";
						})

				$scope.ratingTypeValue = ratingType.map(function(element) {
					return "<" + String(element) + "<";
				})

			}
			
			if (vm.searchCompanies == undefined)
				vm.searchCompanies = ' ';
			
			if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
				$scope.toDateData = vm.unacceptedtoDate;
				$scope.fromDateData = vm.unacceptedfromDate;
			} else {
				$scope.toDateData = '';
				$scope.fromDateData = '';
			}

			if ($scope.fromDateData == undefined) {
				$scope.fromDateData = '';
			}

			if ($scope.toDateData == undefined) {
				$scope.toDateData = '';

			}

			
			var unacceptedRatingInput = '';
			unacceptedRatingInput = "{'ratingAgency' : '" + vm.selectedAgenciesUnacceptedRating
			+ "', 'listedType' : '" + $scope.selectedListingTypeTemp
			+ "', 'ratingType' : '" + $scope.ratingTypeValue
			+ "', 'outStandingRating' : '"+ $scope.selectedScalesShortTermTemp
			+ "', 'nameOfCompany' : '" + vm.unacceptedRatingComp
			+ "', 'fromDate' : '" + $scope.fromDateData
			+ "', 'toDate' : '" + $scope.toDateData
			+ "'}";
			unacceptedRatingInput = unacceptedRatingInput.replace(/\'/g, "\"");
			unacceptedRatingInput = unacceptedRatingInput.replace(/\</g, "\'");

			$scope.inputUnacceptedRatingStr = unacceptedRatingInput;

			RatingListService
					.getUnacceptedRating(unacceptedRatingInput)
					.then(
							function(data) {

								$scope.unacceptedRatingResultList = data.unacceptedRatingResultList[0];
								$scope.unaccptedRatingTotalCount = data.unacceptedRatingResultList[1];
								$scope.totalUniqueUnacceptedRatingCount = data.unacceptedRatingResultList[2];

								$scope.unaccptedRatingGridData = {
									dataProvider : $scope.unacceptedRatingResultList,
									delegate : $scope
								}

								$timeout(
										function() {
											$scope.unacceptedRatingGrid
													.setPreservePager(true);
											$scope.unacceptedRatingGrid
													.setDataProvider($scope.unacceptedRatingResultList);
											if ($scope.unacceptedRatingResultList.length > 0) {
												$scope.unacceptedRatingGrid
														.setTotalRecords($scope.unaccptedRatingTotalCount);
											} else {
												$scope.unacceptedRatingGrid
														.setTotalRecords(0);
											}

											$scope.unacceptedRatingGrid.validateNow();
											$scope.unacceptedRatingGrid.rebuild();
										}, 100);

							}, function(errordata) {

							});

		}

		// code html tree grid

		$scope.unacceptedRatingCompletion = function(event) {
			$scope.unacceptedRatingGrid = event.target;
			$scope.unacceptedRatingGrid.setPreservePager(true);
			$scope.unacceptedRatingGrid.setDataProvider($scope.unacceptedRatingResultList);
			if ($scope.unacceptedRatingResultList.length > 0) {
				$scope.unacceptedRatingGrid.setTotalRecords($scope.unaccptedRatingTotalCount);

			} else {
				$scope.unacceptedRatingGrid.setTotalRecords(0);
			}
			$scope.unacceptedRatingGrid.validateNow();
		}

		// export instrument ISIN data

		$scope.unacceptedRatingExport = function() {
			if (sectionaccess["Rating List.Export Rating List"] != 'Y') {
				$scope.ifError = true;
				$scope.errorMessages = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
				$timeout(function() {

					$scope.ifError = false;
					$scope.errorMessages = "";

				}, 2000);
			} else {
				$scope.checkErrForUnacceptedRating(vm.unacceptedfromDate, vm.unacceptedtoDate);
				
				$scope.selectedListingTypeTemp = [];
				if ($scope.selectedListingType.length > 0) {
					$scope.selectedListingTypeTemp = $scope.selectedListingType
							.map(function(element) {
								return "<" + String(element) + "<"
							})
				}
				
				var ratingType = [];
				$scope.ratingTypeValue = [];
				if (vm.selectedScalesShortTerm != undefined
						&& vm.selectedScalesShortTerm.length > 0) {
					$scope.selectedScalesShortTermTemp = vm.selectedScalesShortTerm
							.map(function(element) {

								if (ratingType.filter(function(x) {
									return x === element.type;
								}).length == 0) {
									ratingType.push(element.type);
								}
								return "<" + String(element.name) + "<";
							})

					$scope.ratingTypeValue = ratingType.map(function(element) {
						return "<" + String(element) + "<";
					})

				}
				
				if (vm.searchCompanies == undefined)
					vm.searchCompanies = ' ';
				
				if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
					$scope.toDateData = vm.unacceptedtoDate;
					$scope.fromDateData = vm.unacceptedfromDate;
				} else {
					$scope.toDateData = '';
					$scope.fromDateData = '';
				}

				if ($scope.fromDateData == undefined) {
					$scope.fromDateData = '';
				}

				if ($scope.toDateData == undefined) {
					$scope.toDateData = '';

				}

				
				var unacceptedRatingInput = '';
				unacceptedRatingInput = "{'ratingAgency' : '" + vm.selectedAgenciesUnacceptedRating
				+ "', 'listedType' : '" + $scope.selectedListingTypeTemp
				+ "', 'ratingType' : '" + $scope.ratingTypeValue
				+ "', 'outStandingRating' : '"+ $scope.selectedScalesShortTermTemp
				+ "', 'nameOfCompany' : '" + vm.unacceptedRatingComp
				+ "', 'fromDate' : '" + $scope.fromDateData
				+ "', 'toDate' : '" + $scope.toDateData
				+ "'}";
				unacceptedRatingInput = unacceptedRatingInput.replace(/\'/g, "\"");
				unacceptedRatingInput = unacceptedRatingInput.replace(/\</g, "\'");				

				$http({
					url : 'api/ratingList/unacceptedRatingExcelExportData',
					method : 'POST',
					data : unacceptedRatingInput,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {

									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'Unaccepted Rating.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'Unaccepted Rating.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
			}
		}

		// server side pagination for Unaccepted rating

		$scope.filterPageSortChangeHandlerUnacceptedRatingList = function(evt1) {
			var grid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 30,
				searchText : $scope.inputInstrumentsIsinDataTemp,
				typeOfRatingList : 'unacceptedRating',
				sortColumn : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? evt1.filter.sorts[0].sortColumn
						: null,
				sort : (evt1.filter.sorts != undefined && evt1.filter.sorts.length > 0) ? ((evt1.filter.sorts[0].isAscending) ? "asc"
						: "desc")
						: "asc",

			};

			baseRequest('api/ratingList/getFilterServerSidePagination', filter)
					.then(
							function(response) {
								grid.setPreservePager(true);
								grid
										.setDataProvider(response.data.typeOfRatingList);
								$scope.unaccptedRatingPaginationList = response.data.typeOfRatingList;
								if ($scope.unaccptedRatingPaginationList.length > 0) {
									$scope.unaccptedRatingTotalPaginationCount = response.data.totalCountOfList;
									grid
											.setTotalRecords($scope.unaccptedRatingTotalPaginationCount);
								} else {
									grid.setTotalRecords(0);
								}
								grid.validateNow();

							});

		}
		

		$scope.getRatingActions();
		$scope.getRatingScales();
		$scope.getRatingScalesData();
		$scope.getInstrumentList();
		$scope.getSfRatingType();
		$scope.getConstitutionData();
		$scope.gridIndustryTree();
		$scope.getRatingOutlooks();
		//$scope.getExistingPortfolios();
		$scope.sectionAccessData();

	}

})();
